/* eslint-disable camelcase */
export const ru = {
  AdminDashboard: {
    expiringLicenses: {
      popupHeader: "Внимание",
      title:
        "Список аккаунтов, у которых лицензия истекает в течение %cnt% дней",
      understandButton: "Понятно",
    },
    ActivitiesList: {
      labStatus: {
        error: "ошибка",
        success: "успешно",
      },
      labels: {
        action: "Действие",
        context: "Описание",
        date: "Дата",
        errorMsg: "Описание ошибки",
        executor: "Исполнитель",
        status: "Статус",
      },
    },
    Licence: {
      deletePopup: {
        confirmationText: "Да, я хочу удалить лицензию",
        contentText:
          "После удаления лицензии будет невозможно назначать обследования",
        headerText: "Вы уверены, что хотите удалить лицензию?",
      },
      labels: {
        expireDate: "Срок действия лицензии",
        licenseDate: "Дата выдачи лицензии",
        methodologyList: "Доступные методики",
        testsList: "Доступные тесты",
      },
    },
    PsychLab: {
      anonymizePopup: {
        headerText: "Вы уверены, что хотите анонимизировать данные клиента?",
        contentText:
          "Все обследования и данные обследуемых будут анонимизированы и перенесены в учётную запись Psychometric (новые и незавершённые обследования будут удалены). Операция необратима. Вы хотите продолжить?",
        confirmationText: "Да, я хочу анонимизировать данные",
      },
      deletePopup: {
        confirmationText: "Да, я хочу удалить учетную запись клиента",
        contentText:
          "После удаления учетной записи клиента будет невозможно восстановить данные",
        headerText: "Вы уверены, что хотите удалить учетную запись клиента?",
      },
    },
    PsychLabManagment: {
      PsychLabView: {
        labels: {
          details: "Подробности",
          download: "Скачать",
          edit: "Редактировать",
          generate: "Сгенерировать",
          name: "Название теста",
          nameFile: "Имя файла",
          print: "Печать",
          result: "Результат",
          type: "Тип документа",
        },
        tabs: {
          activityAction: "название действия",
          activityContext: "описание",
          activityDate: "дата",
          activityExecutor: "исполнитель",
          activityId: "ID",
          activityLogs: "Журнал действий",
          activityLogsFile: "журнал_действий",
          activityStatus: "статус",
          license: "Лицензия",
          psychLabData: "Данные клиента",
          stats: "Статистика",
          theme: "Внешний вид",
          parameters: "Параметры",
          priceList: "Ценник",
          users: "Пользователи",
        },
        parameters: {
          header: "Параметры клиента",
          noParameters:
            "Нет доступных параметров для этого клиента. Проверьте, активна ли лицензия.",
        },
      },
      breadcrumbs: {
        add: "Добавить учетную запись клиента",
        addLicense: "Добавить лицензию",
        addUser: "Добавить учетную запись пользователя",
        dashboard: "Панель пользователя",
        edit: "Редактировать учетную запись клиента",
        editLicense: "Редактировать лицензию",
        editUser: "Редактировать учетную запись пользователя",
        psychLabs: "Картотека клиентов",
      },
      header: {
        add: "Добавить учетную запись клиента",
        addLicense: "Добавить лицензию",
        addUser: "Добавить учетную запись пользователя",
        edit: "Редактировать учетную запись клиента",
        editLicense: "Редактировать лицензию",
        editUser: "Редактировать учетную запись пользователя",
      },
    },
    PsychologicalLabsList: {
      labStatus: {
        disabled: "неактивный",
        enabled: "активный",
      },
      labels: {
        all: "все",
        clientId: "ID клиента",
        createDate: "Дата создания",
        details: "Подробности",
        examinationsCnt: "Количество обследований",
        examineesCnt: "Количество обследуемых",
        expireDate: "Срок действия учетной записи",
        licenseExpireDate: "Срок действия лицензии",
        moreThen: "больше чем",
        name: "Название клиента",
        of: "из",
        psychCnt: "Количество пользователей",
        status: "Статус",
        systemAccount: "системная учётная запись",
        taskPerPage: "Строк на странице:",
        usersCnt: "Количество пользователей",
      },
      expiryWarningTooltip:
        "Срок действия лицензии или учетной записи истекает в течение %count% дней",
      expiredWarningTooltip: "Срок действия лицензии или учётной записи истёк",
      inactiveAccountTooltip: "Учётная запись неактивна",
    },
    StatsList: {
      statFileName: "статистика_обследований.xlsx",
    },
    UsersList: {
      deletePopup: {
        confirmationText: "Да, я хочу удалить учетную запись пользователя",
        contentText:
          "После удаления учетной записи пользователя её невозможно будет восстановить",
        headerText:
          "Вы уверены, что хотите удалить учетную запись пользователя?",
      },
      labStatus: {
        adminRole: "администратор",
        disabled: "неактивный",
        enabled: "активный",
        superUserRole: "супер администратор",
        userBaseRole: "регистратор",
        userRole: "пользователь",
      },
      labels: {
        email: "Email",
        examinationCnt:
          "Количество обследований (все / назначенные / завершенные)",
        examinationCnt1: "Количество обследований",
        examinationCnt2: "все: ",
        examinationCnt3: "назначенные: ",
        examinationCnt4: "завершенные: ",
        examineeCnt: "Количество участников",
        firstName: "Имя",
        isActive: "Статус",
        isStaff: "Роль",
        lastName: "Фамилия",
      },
      toolTip: {
        move: "переместить обследования и папки",
        delete: "удалить",
        edit: "редактировать",
      },
    },
    emptyState: {
      header: "Учетные записи клиентов еще не добавлены",
      info: "Чтобы увидеть список клиентов, добавьте хотя бы одну учетную запись.",
    },
    emptyStateLicense: {
      header: "Лицензии еще не добавлены",
      info: "Чтобы увидеть лицензию, добавьте её.",
    },
    emptyStateUsers: {
      header: "Учетные записи пользователей еще не добавлены",
      info: "Чтобы увидеть список пользователей, добавьте хотя бы одну учетную запись.",
    },
    header: "Картотека клиентов",
    showInactiveAccounts: "Показать неактивные учётные записи",
    kebabMenu: {
      print: "Распечатать контракт",
      profile: "Перейти к профилю обследуемого",
    },
  },
  AdminSearchEngine: {
    enterFilter:
      "Вы можете искать по названию, ID, адресу, ИНН, дате создания, дате истечения срока действия учетной записи клиента в формате ГГГГ-ММ-ДД, имени, фамилии, электронной почте пользователя, дате истечения срока действия лицензии в формате ГГГГ-ММ-ДД, методологии, тесту.",
    header: "Поиск клиентов",
    noResults: "Нет результатов поиска",
    noResultsForFilter:
      "Не найдено клиентов, соответствующих введенным требованиям.",
    placeholderDesktop:
      "название, ID, адрес, ИНН, дата создания, дата истечения срока действия учетной записи клиента в формате ГГГГ-ММ-ДД, имя, фамилия, электронная почта пользователя, дата истечения срока действия лицензии, методология, тест",
    placeholderMobile: "Поиск",
    searchForExaminees: "Поиск клиентов",
  },
  ArchiveExaminationList: {
    emptyState: {
      info: "Нет архивных обследований, назначенных этому участнику",
    },
  },
  Backend: {
    Could_not_bind_users_PsychologicalLab_with_the_directory:
      "Не удалось связать учреждение пользователя с папкой.",
    Could_not_bind_users_PsychologicalLab_with_the_examinee:
      "Не удалось связать учреждение пользователя с обследуемым.",
    Directory_has_related_Examinees:
      "Невозможно удалить Папку: Папка содержит связанных обследуемых.",
    Directory_with_given_name_already_exists:
      "Папка с указанным именем уже существует.",
    Examination_Card_does_not_have_a_defined_NormSet:
      "Карта обследования не имеет назначенной нормы обследования.",
    Examinee_with_the_given_id_exists_in_this_psychological_lab:
      "Обследуемый с указанным ID уже существует в базе данных.",
    Generated_ID_conflict: "Ошибка генерации идентификатора для испытуемого.",
    Incorrect_credentials: "Неверный пароль.",
    Invalid_token_Please_regenerate_password_reset_link:
      "Недействительный токен, пожалуйста, сгенерируйте новую ссылку для сброса пароля.",
    Legacy_data_instance_not_found: "Архивные данные не найдены.",
    Legacy_data_validation_failed: "Ошибка проверки архивных данных.",
    Ongoing_examination:
      "Невозможно удалить Обследование. Обследование в процессе.",
    User_has_related_Examinations_or_Directories:
      "Невозможно удалить Пользователя: У пользователя есть связанные обследования или папки.",
    The_Examinee_has_related_Examinations:
      "Невозможно удалить Обследуемого: У обследуемого есть связанные обследования.",
    The_new_pin_cannot_be_the_same_as_the_previous_one:
      "Новый ПИН-код не может быть таким же, как предыдущий.",
    The_password_cannot_be_the_same_as_the_previous_one:
      "Пароль не может быть таким же, как предыдущий.",
    Token_not_recognized: "Токен не распознан.",
    Unable_to_delete_default_directory:
      "Невозможно удалить Папку по умолчанию.",
    Unable_to_parse_Examination_Aim: "Ошибка проверки Цели Обследования.",
    Unable_to_parse_Occupational_Medicine_Basic_Info_data:
      "Ошибка проверки данных Медицины Труда.",
    Unrecognized_email:
      "Адрес электронной почты не распознан или учетная запись не активирована.",
    Unrecognized_proxy_error_occurred_while_fetching_legacy_data:
      "Произошла нераспознанная ошибка при получении архивных данных.",
    Unrecognized_token_Please_regenerate_password_reset_link:
      "Нераспознанный токен, пожалуйста, сгенерируйте новую ссылку для сброса пароля.",
    User_activation_code_does_not_exist:
      "Указанный код активации не существует.",
    User_activation_code_has_already_been_used:
      "Код активации уже использован.",
    User_with_given_id_does_not_exist:
      "Пользователь с указанным ID не существует.",
    Validation_failed: "Проверка введенных данных не удалась.",
  },
  Buttons: {
    accept: "Согласен",
    addDirectory: "Добавить папку",
    addExaminee: "Добавить обследуемого",
    addMobileExaminee: "Добавить",
    addPsychLab: "Добавить аккаунт клиента",
    addPsychLabLic: "Добавить лицензию",
    addPsychUser: "Добавить аккаунт пользователя",
    addPsychUserMobile: "Добавить пользователя",
    addUser: "Добавить аккаунт пользователя",
    alreadyAssigned: "Назначено",
    alreadyAssignedExamination: "Обследование в процессе",
    assign: "Назначить",
    assignExamination: "Назначить обследование",
    back: "Назад",
    backToLogin: "Вернуться на страницу входа",
    begin: "Начать",
    cancel: "Отменить",
    change: "Изменить",
    clear: "Очистить",
    close: "Закрыть",
    confirm: "Подтвердить",
    continue: "Далее",
    createExamination: "Назначить обследование",
    delete: "Удалить",
    anonymize: "Анонимизировать",
    deleteExaminee: "Удалить обследуемого",
    deleteExaminees: "Удалить обследуемых",
    anonymizePsychLab: "Анонимизировать данные",
    deletePsychLab: "Удалить аккаунт клиента",
    deletePsychLabLic: "Удалить лицензию",
    disable2FA: "Отключить двухфакторную аутентификацию",
    downloadAll: "Скачать все",
    edit: "Редактировать",
    editExaminee: "Редактировать обследуемого",
    editPsychLab: "Редактировать аккаунт клиента",
    editPsychLabLic: "Редактировать лицензию",
    editPsychLabUser: "Редактировать аккаунт пользователя",
    enable2FA: "Включить двухфакторную аутентификацию",
    examinationWithLawBase: "Обследование с правовым основанием",
    examinationWithNoLawBase: "Обследование без правового основания",
    exit: "Выход",
    exportActivities: "Экспорт в файл XLS",
    exportResults: "Сгенерировать экспорт",
    generate: "Сгенерировать",
    generateAndPrint: "Сгенерировать и распечатать",
    go: "Перейти",
    goToDashboard: "Перейти в панель пользователя",
    importExaminees: "Импортировать испытуемых",
    login: "Войти",
    loginPsychLab: "Войти в аккаунт клиента",
    move: "Переместить",
    moveExaminee: "Переместить обследуемого",
    moveExaminees: "Переместить обследуемых",
    examineesIdsList: "Скачать список обследуемых",
    ok: "Ок",
    print: "Печать",
    printContract: "Распечатать контракт",
    save: "Сохранить",
    saveAndInvate: "Сохранить и пригласить",
    saveAndPrint: "Сохранить и распечатать",
    savePassword: "Сохранить пароль",
    savePin: "Сохранить ПИН",
    saveSettings: "Сохранить настройки",
    search: "Поиск",
    sendEmail: "Отправить сообщение",
    sendLink: "Отправить ссылку",
    setNewPassword: "Установить новый пароль",
    setPassword: "Установить пароль",
    setPin: "Установить ПИН",
    showActivities: "Показать",
    skipTests: "Пропустить тесты",
    understood: "Понятно",
    unblockedExam: "Разблокировать обследования",
    enable2FAIcon: "Включить двухфакторную аутентификацию",
    disable2FAIcon: "Отключить двухфакторную аутентификацию",
    openFolder: "Открыть",
  },
  Common: {
    deleteExamineePopup: {
      header: "Вы уверены, что хотите удалить обследуемого?",
      text: "После удаления обследуемого восстановление данных будет невозможно",
      confirmationText: "Да, я хочу удалить обследуемого",
    },
    deleteExamineesPopup: {
      header: "Вы уверены, что хотите удалить выбранных обследуемых?",
      text: "После удаления обследуемых восстановление данных будет невозможно",
      confirmationText: "Да, я хочу удалить обследуемых",
    },
    deleteExamineeWithExamPopup: {
      header:
        "Вы уверены, что хотите удалить обследуемого вместе с обследованиями?",
      text: "После удаления обследуемого вместе с обследованиями восстановление данных будет невозможно",
      confirmationText:
        "Да, я хочу удалить обследуемого вместе с обследованиями",
    },
    deleteExamineesWithExamPopup: {
      header:
        "Вы уверены, что хотите удалить выбранных обследуемых вместе с обследованиями?",
      text: "После удаления обследуемых вместе с обследованиями восстановление данных будет невозможно",
      confirmationText:
        "Да, я хочу удалить обследуемых вместе с обследованиями",
    },
    logAdminAsUserPopup: {
      header: "Ошибка",
      text: "Не удалось войти в аккаунт клиента",
    },
    menu: {
      breadcrumbsPsychLab: "Записи клиентов",
      contact: "Помощь",
      dashboard: "Панель пользователя",
      emailSender: "Отправка сообщения",
      exportResults: "Экспорт результатов",
      examineeRegistry: "Реестр обследуемых",
      folders: "Записи обследуемых",
      importExaminees: "Импорт испытуемых",
      logout: "Выйти",
      psychlabs: "Записи клиентов",
      search: "Поиск",
      settings: "Настройки",
      priceList: "Ценник",
      summary: "Реестр обследуемых",
    },
    seo: {
      addExaminee: "Добавить обследуемого",
      addPsychLab: "Добавить аккаунт клиента",
      addPsychLabLic: "Добавить лицензию",
      dashboard: "Панель пользователя",
      editExaminee: "Редактировать обследуемого",
      emailSender: "Отправка сообщения",
      examinationAssignment: "Назначение обследования с правовым основанием",
      examinationCard: "Карта Обследования",
      exportResults: "Экспорт результатов",
      folders: "Картотека обследуемых",
      helpdesk: "Помощь",
      helpdeskDocuments: "Документы помощи",
      judgement: "Заключение",
      login: "Вход",
      onboarding: "Онбординг",
      report: "Отчет",
      resetPassword: "Сброс пароля",
      search: "Поиск",
      setNewPassword: "Установка нового пароля",
      settings: "Настройки",
      priceList: "Ценник",
    },
    twoFactorAuth: "Двухфакторная аутентификация",
    warningPopup: {
      header: "Вы уверены, что хотите выйти?",
      headerSave: "Пожалуйста, заполните все обязательные поля!",
      promptLogout:
        "Вы будете автоматически выйдете из системы через PROMPT_TIME_MINUTES минуту из-за отсутствия активности.",
      promptLogoutCountdown:
        "Вы будете автоматически выйдете из системы через COUNTDOWN_TIME из-за отсутствия активности.",
      logoutWarningTitle: "Ваша сессия скоро истечёт",
      promptLogoutInfo:
        "Из-за отсутствия активности вы будете автоматически выйдете из системы через минуту.",
      stayLoggedIn: "Продлить сессию",
      logoutNow: "Выйти сейчас",
      text: "Внесенные вами изменения не будут сохранены",
      textSave: "Обязательные поля могут также находиться на других вкладках",
    },
  },
  Contact: {
    header: "Техническая поддержка",
  },
  WhatsNew: {
    closeButton: "Понятно",
  },
  LicenseExpire: {
    popup: {
      header: "Внимание!",
      messageManyDaysBold:
        "Срок действия лицензии или учётной записи истечёт через %cnt% дн.",
      messageOneDayBold:
        "Срок действия лицензии или учётной записи истечёт через %cnt% дн.",
      messageRest:
        "Свяжитесь с нами для сохранения непрерывности работы и доступа ко всем функциям системы.",
      understandButton: "Понятно",
      dontShowAgain: "Больше не показывать",
    },
    expiredPopup: {
      header: "Лицензия истекла",
      message:
        "Срок действия вашей лицензии на проведение тестов в системе Optimis истёк.",
      okButton: "ОК",
    },
  },
  Cookies: {
    consent:
      "Для обеспечения услуг наивысшего качества мы используем файлы cookie. Использование нашего сайта означает, что они будут размещены на вашем устройстве. Вы можете изменить настройки вашего браузера в любое время.",
    cookiePolicy: {
      moduleText1:
        "Сервис использует файлы cookie. В данном документе мы информируем об использовании файлов cookie в сервисе Optimis.",
      moduleText10:
        "Меню > Настройки > Конфиденциальность > Файлы cookie – выберите соответствующую опцию.",
      moduleText2:
        "Файлы cookie - это небольшие фрагменты текста, кода, которые отправляются в браузер и которые браузер отправляет обратно. Некоторые файлы cookie иногда сохраняются на устройстве при просмотре сервиса Optimis. Существуют различные типы файлов cookie. Файлы cookie, используемые в сервисе Optimis, были разделены на следующие категории:\n      a. необходимые файлы cookie\n      b. функциональные\n      c. аналитические",
      moduleText3:
        "a. Файлы cookie, которые необходимы для использования сервиса Optimis, служат, в частности, для обеспечения стабильности его функционирования (измеряют трафик и защищают нас от перегрузки). Эти файлы cookie абсолютно необходимы для того, чтобы сервис Optimis мог предоставлять услуги, и/или исключительно для целей передачи услуг и/или сервиса Optimis.\n      b. Функциональные файлы cookie - запоминание выбранных настроек конфиденциальности, заполнений онлайн-форм, запоминание настроек веб-сайта.",
      moduleText4:
        "При посещении сайта www.gov.pl будет отображено сообщение, информирующее об использовании файлов cookie.",
      moduleText5:
        "В большинстве интернет-браузеров можно: удалять файлы cookie с жесткого диска компьютера (из настроек браузера), блокировать все отправляемые файлы cookie или установить предупреждение перед их сохранением на диске.\n      Следует иметь в виду, что изменения настроек этих файлов, заключающиеся в ограничении их использования, могут повлиять на некоторые функциональные возможности, доступные на использующих их веб-сайтах.\n      Ниже мы указываем способ изменения настроек cookie в наиболее популярных браузерах:",
      moduleText6:
        "Меню > Настройки > Конфиденциальность и безопасность – выберите соответствующую опцию.",
      moduleText7:
        "Меню > Настройки > Файлы cookie и разрешения сайта – выберите соответствующую опцию.",
      moduleText8:
        "Меню > Настройки > Конфиденциальность и безопасность > Куки и данные сайтов – выберите соответствующую опцию.",
      moduleText9:
        "Меню > Настройки > Конфиденциальность и безопасность – выберите соответствующую опцию.",
      moduleTitle1: "1. Введение",
      moduleTitle10: "Safari",
      moduleTitle2: "2. Что такое файлы cookie?",
      moduleTitle3: "3. Какие файлы cookie мы используем?",
      moduleTitle4: "4. Согласие на использование файлов cookie",
      moduleTitle5: "5. Изменение настроек файлов cookie",
      moduleTitle6: "Google Chrome",
      moduleTitle7: "Internet Explorer",
      moduleTitle8: "Mozilla Firefox",
      moduleTitle9: "Opera",
      title: "Политика в отношении файлов cookie",
    },
    header: "Разрешение на использование cookies",
    policy: "Политика использования файлов cookie",
    showPolicy: "Посмотреть политику использования файлов cookie",
  },
  Dashboard: {
    emptyState: {
      header: "Нет недавно добавленных обследуемых",
      info: "Чтобы увидеть список обследуемых, добавьте хотя бы одного.",
    },
    footer: {
      day: "день",
      days: "дней",
      lastFailedLogin: "Последний неудачный вход",
      lastLogin: "Последний вход",
      passwordExpired: "Срок действия вашего пароля истекает через",
      versionLabel: "Версия",
    },
    header: "Недавно добавленные люди",
    kebabMenu: {
      print: "Распечатать контракт",
      profile: "Перейти к профилю обследуемого",
    },
  },
  Directory: {
    defaultFolderName: "Папка по умолчанию",
    emptyState: {
      header: "В выбранной папке нет обследуемых",
      info: "Чтобы увидеть список обследуемых в папке, добавьте хотя бы одного обследуемого",
    },
    header: "Картотека обследуемых",
    kebabMenu: {
      addDirectory: "Добавить папку",
      addExaminee: "Добавить обследуемого",
      delete: "Удалить папку",
      edit: "Изменить название папки",
    },
    labels: {
      examineeCount: "Люди",
      name: "Название папки",
      owner: "Владелец",
    },
    popup: {
      create: "Введите название папки",
      edit: "Изменить название папки",
    },
    popups: {
      delete: {
        confirmationHeader: "Вы уверены, что хотите удалить папку?",
        confirmationText: "После удаления папку невозможно будет восстановить.",
        confirmationCheckboxLabel: "Да, я хочу удалить папку",
      },
    },
  },
  DirectoryPreview: {
    breadcrumbs: "Картотека обследуемых",
    headerPopup: "Переместить обследуемых",
    kebabMenu: {
      delete: "Удалить обследуемого",
      edit: "Редактировать данные обследуемого",
      move: "Переместить обследуемого",
    },
    labels: {
      firstName: "Имя",
      lastModification: "Последняя активность",
      lastName: "Фамилия",
      peselSlashIdentifier: "СНИЛС / Идентификатор",
    },
  },
  MoveExamAndFoldersPopup: {
    header: "Переместить обследования и папки",
    userInfo: "Данные пользователя",
    examinations: "Количество обследований",
    examAll: "всего обследований",
    examAssign: "назначено обследований",
    examDone: "выполнено обследований",
    directories: "Папки пользователя",
    noDirectories: "Нет папок",
    selectTargetUser:
      "Выберите пользователя, которому вы хотите перенести обследования и папки",
    selectTargetUserLabel: "Целевой пользователь",
    noActiveUsers: "Нет активных пользователей",
    moveButton: "Переместить",
  },
  DocumentationManagement: {
    ExaminationCard: {
      examinationCourse: {
        addExaminationExtendedResults: "Добавить дополнительный результат",
        careerHistory: "История работы",
        cognitiveExtendedResultsHeader:
          "Оценка и описание интеллектуальных способностей и познавательных процессов обследуемого - дополнительные результаты",
        cognitiveResultsHeader:
          "Оценка и описание интеллектуальных способностей и познавательных процессов обследуемого (в рамках рекомендованной методики)",
        conclusions: "Выводы",
        conclusionsRecomendation: "Выводы и рекомендации",
        deletePopup: {
          confirmationText: "Да, я хочу удалить результат",
          contentText:
            "После удаления результата можно восстановить его исходное содержание путем обновления данных",
          headerText: "Вы уверены, что хотите удалить этот результат?",
        },
        examinationExtendedResultsHeader:
          "Название теста и дополнительные результаты",
        examinationExtendedResultsT2WHeader: "Дополнительно",
        examinationResultsHeader:
          "Название теста и результаты (в рамках рекомендованной методики)",
        examinationResultsT2WHeader: "Рекомендованная методика",
        forcedUpdateBody:
          "Для разблокировки формы заполните Опрос для Обследования, выберите стандарт во вкладке Обследуемый и обновите Карту Обследования данными из Опроса и Результатами.",
        forcedUpdateHeader:
          "Обновить Карту Обследования данными из Опроса и Результатами",
        header: "Данные прямого опроса и наблюдения за обследуемым",
        methodology: "Методы обследования и результаты",
        occupationalMedicineAdditionalInfo:
          "Дополнительная информация - Медицина труда",
        personalityExtendedResultsHeader:
          "Оценка и описание личности обследуемого, включая функционирование в сложных ситуациях и социальную зрелость - дополнительные результаты",
        personalityResultsHeader:
          "Оценка и описание личности обследуемого, включая функционирование в сложных ситуациях и социальную зрелость (в рамках рекомендованной методики)",
        psychomotorExtendedResultsHeader:
          "Психомоторные показатели - дополнительные результаты",
        psychomotorResultsHeader:
          "Психомоторные показатели (в рамках рекомендованной методики)",
        recommendations: "Рекомендации",
      },
      examinee: {
        aim: "Цель обследования",
        chosenNormSet: "Стандарт, применяемый при обследовании",
        entityDirectingToExamination: "Направляющая организация",
        examinationDate: "Дата обследования",
        previousExaminationDate: "Дата предыдущего обследования",
        t2dAim: {
          drivingInstructorAim:
            "Определение отсутствия или наличия противопоказаний к выполнению обязанностей инструктора/экзаменатора/инструктора по технике вождения.",
          drivingVehiclesAim:
            "Определение отсутствия или наличия противопоказаний к управлению транспортными средствами.",
          emergencyDriverAim:
            "Определение отсутствия или наличия противопоказаний к управлению спецтранспортом или инкассаторским транспортом.",
          professionalDriverAim:
            "Определение отсутствия или наличия противопоказаний к работе в должности водителя.",
        },
      },
      fetchUpdated: "Обновить данными опроса и результатами",
      header: "Карта обследования",
      headerTEST2ARMS: "Карта обследования TEST2ARMS",
      headerTEST2DRIVE: "Карта обследования TEST2DRIVE",
      headerTEST2SAFE: "Карта обследования TEST2SAFE",
      headerTEST2WORK: "Карта обследования TEST2WORK",
      judgment: {
        judgment: "Содержание заключения",
        justification: "Обоснование заключения",
        justificationText: "Содержание обоснования",
        recommendations: "Рекомендации",
        result: "Результат психологического обследования",
        sent: "Заключение/копия заключения отправлены, если применимо",
        t2d: {
          existing: "имеются",
          lack: "отсутствуют",
          questions: {
            drivingInstructorContraindication:
              "Противопоказания к выполнению обязанностей инструктора/экзаменатора/инструктора по технике вождения.",
            drivingVehiclesContraindication:
              "Противопоказания к управлению транспортными средствами.",
            emergencyVehicleDriverContraindication:
              "Противопоказания к управлению спецтранспортом или инкассаторским транспортом.",
            professionalDriverContraindication:
              "Противопоказания к работе в должности водителя.",
          },
        },
        to: "к",
      },
      tabs: {
        courseOfExamination: "Ход обследования",
        examinee: "Обследуемый",
        results: "Результаты психологического обследования",
      },
      tooltipFetchUpdated:
        "Это действие удалит все несохраненные изменения из Хода обследования",
      tooltipFetchUpdatedDisabled:
        "Для разблокировки действия выберите стандарт обследования.",
    },
    consultation: {
      breadcrumbs: "Психологическая консультация",
      examineeData: "Данные обследуемого",
      statement: "заключаю",
    },
    emptyState: {
      header: "Обследование не завершено",
    },
    judgment: {
      ART_1: "ст. 39к ч. 3 п. 1",
      ART_2: "ст. 39к ч. 3 п. 2",
      appeal: "На данное заключение может быть подана апелляция в",
      appealDate: "В течение",
      appealDay: "В течение",
      appealDay2: "дней с момента получения",
      appealDayTlt: "Количество дней",
      civilExplosives: {
        false:
          "проявляет нарушения психологического функционирования и, следовательно, не может осуществлять деятельность по приобретению и хранению взрывчатых материалов гражданского назначения",
        true: "не проявляет нарушений психологического функционирования и, следовательно, может осуществлять деятельность по приобретению и хранению взрывчатых материалов гражданского назначения",
      },
      drivingExaminer: {
        false:
          "имеются противопоказания к выполнению обязанностей инструктора/экзаменатора/инструктора по технике вождения",
        true: "отсутствуют противопоказания к выполнению обязанностей инструктора/экзаменатора/инструктора по технике вождения",
      },
      drivingInstructor: {
        false:
          "имеются противопоказания к выполнению обязанностей инструктора/экзаменатора/инструктора по технике вождения",
        true: "отсутствуют противопоказания к выполнению обязанностей инструктора/экзаменатора/инструктора по технике вождения",
      },
      drivingLicense: "В отношении водительского удостоверения категории",
      drivingVehicles: {
        false:
          "имеются психологические противопоказания к управлению транспортными средствами",
        true: "отсутствуют психологические противопоказания к управлению транспортными средствами",
      },
      emergencyVehicleDriver: {
        false:
          "имеются противопоказания к управлению спецтранспортом или инкассаторским транспортом",
        true: "отсутствуют противопоказания к управлению спецтранспортом или инкассаторским транспортом",
      },
      examiner_ART_1: "ст. 34 ч. 5 п. 1",
      examiner_ART_2: "ст. 34 ч. 5 п. 2",
      firearmLicense: {
        false:
          "относится к лицам, указанным в ст. 15 ч. 1 п. 3 закона от 21 мая 1999 г. об оружии и боеприпасах и не может владеть оружием",
        true: "не относится к лицам, указанным в ст. 15 ч. 1 п. 3 закона от 21 мая 1999 г. об оружии и боеприпасах и может владеть оружием",
      },
      header: {
        base: "Заключение",
        baseAppeal: "Апелляционное заключение",
        baseAppealFooter: "Данное заключение является окончательным.",
        civilExplosives:
          "Лицензируемая деятельность - для гражданского использования",
        civilExplosivesAppeal:
          "Лицензируемая деятельность - для гражданского использования - апелляция",
        driver: "Управление транспортными средствами",
        drivingExaminer: "Экзаменатор",
        drivingInstructor: "Инструктор",
        emergencyVehicleDriver: "Водитель спецтранспорта",
        firearmLicense: "Разрешение на оружие",
        militaryExplosives:
          "Лицензируемая деятельность - военного или полицейского назначения",
        occupationalMedicine: "Медицина труда",
        physicalProtection: "Работник охраны",
        profesionalDriver: "Должность водителя",
      },
      isAppealTitle: "АПЕЛЛЯЦИОННОЕ ЗАКЛЮЧЕНИЕ",
      judgmentNumber: "Психологическое заключение №",
      judgmentNumberAppeal: "Психологическое заключение №",
      legalBais: "Правовое основание обследования",
      militaryExplosives: {
        false:
          "проявляет существенные нарушения психологического функционирования, препятствующие осуществлению или руководству хозяйственной деятельностью в сфере производства и оборота взрывчатых материалов, оружия, боеприпасов и изделий и технологий военного или полицейского назначения",
        true: "не проявляет существенных нарушений психологического функционирования, препятствующих осуществлению или руководству хозяйственной деятельностью в сфере производства и оборота взрывчатых материалов, оружия, боеприпасов и изделий и технологий военного или полицейского назначения",
      },
      nextLegalBasis: "Правовое основание следующего обследования:",
      occupationalMedicine: {
        false: "имеются психологические противопоказания к",
        justification: "Обоснование",
        true: "отсутствуют психологические противопоказания к",
      },
      occupationalMedicineStatement: "Постановляю*",
      physicalProtection: {
        false:
          "не обладает способностью выполнять обязанности работника физической охраны",
        true: "обладает способностью выполнять обязанности работника физической охраны",
      },
      professionalDriver: {
        false:
          "имеются психологические противопоказания к работе в должности водителя",
        true: "отсутствуют психологические противопоказания к работе в должности водителя",
      },
      remarks: "Примечания",
      statement: "Заключаю*",
      statementThat: "Заключаю, что",
    },
    names: {
      CivilExplosivesJudgment:
        "Заключение об оружии и взрывчатых веществах для гражданского использования",
      CivilExplosivesJudgmentTEST2ARMS:
        "Заключение об оружии и взрывчатых веществах для гражданского использования",
      CivilExplosivesJudgmentTEST2DRIVE:
        "Заключение об оружии и взрывчатых веществах для гражданского использования",
      CivilExplosivesJudgmentTEST2SAFE:
        "Заключение об оружии и взрывчатых веществах для гражданского использования",
      CivilExplosivesJudgmentTEST2WORK:
        "Заключение об оружии и взрывчатых веществах для гражданского использования",
      DriverJudgment: "Заключение на право управления ТС",
      DriverJudgmentTEST2ARMS: "Заключение на право управления ТС",
      DriverJudgmentTEST2DRIVE: "Заключение на право управления ТС",
      DriverJudgmentTEST2SAFE: "Заключение на право управления ТС",
      DriverJudgmentTEST2WORK: "Заключение на право управления ТС",
      DrivingExaminerJudgment: "Заключение экзаменатора по вождению",
      DrivingExaminerJudgmentTEST2ARMS: "Заключение экзаменатора по вождению",
      DrivingExaminerJudgmentTEST2DRIVE: "Заключение экзаменатора по вождению",
      DrivingExaminerJudgmentTEST2SAFE: "Заключение экзаменатора по вождению",
      DrivingExaminerJudgmentTEST2WORK: "Заключение экзаменатора по вождению",
      DrivingInstructorJudgment: "Заключение инструктора по вождению",
      DrivingInstructorJudgmentTEST2ARMS: "Заключение инструктора по вождению",
      DrivingInstructorJudgmentTEST2DRIVE: "Заключение инструктора по вождению",
      DrivingInstructorJudgmentTEST2SAFE: "Заключение инструктора по вождению",
      DrivingInstructorJudgmentTEST2WORK: "Заключение инструктора по вождению",
      DrivingTechniqueInstructorJudgment:
        "Заключение инструктора по технике вождения",
      EmergencyVehicleDriverJudgment:
        "Заключение на управление спецтранспортом",
      EmergencyVehicleDriverJudgmentTEST2ARMS:
        "Заключение на управление спецтранспортом",
      EmergencyVehicleDriverJudgmentTEST2DRIVE:
        "Заключение на управление спецтранспортом",
      EmergencyVehicleDriverJudgmentTEST2SAFE:
        "Заключение на управление спецтранспортом",
      EmergencyVehicleDriverJudgmentTEST2WORK:
        "Заключение на управление спецтранспортом",
      ExaminationCard: "Карта обследования",
      ExaminationCardTEST2ARMS: "Карта обследования TEST2ARMS",
      ExaminationCardTEST2DRIVE: "Карта обследования TEST2DRIVE",
      ExaminationCardTEST2SAFE: "Карта обследования TEST2SAFE",
      ExaminationCardTEST2WORK: "Карта обследования TEST2WORK",
      FirearmLicenseJudgment: "Заключение на право владения оружием",
      FirearmLicenseJudgmentTEST2ARMS: "Заключение на право владения оружием",
      FirearmLicenseJudgmentTEST2DRIVE: "Заключение на право владения оружием",
      FirearmLicenseJudgmentTEST2SAFE: "Заключение на право владения оружием",
      FirearmLicenseJudgmentTEST2WORK: "Заключение на право владения оружием",
      MilitaryExplosivesJudgment:
        "Заключение на полицейское/военное оружие и материалы",
      MilitaryExplosivesJudgmentTEST2ARMS:
        "Заключение на полицейское/военное оружие и материалы",
      MilitaryExplosivesJudgmentTEST2DRIVE:
        "Заключение на полицейское/военное оружие и материалы",
      MilitaryExplosivesJudgmentTEST2SAFE:
        "Заключение на полицейское/военное оружие и материалы",
      MilitaryExplosivesJudgmentTEST2WORK:
        "Заключение на полицейское/военное оружие и материалы",
      OccupationalMedicineJudgmentTEST2ARMS: "Заключение по медицине труда",
      OccupationalMedicineJudgmentTEST2DRIVE: "Заключение по медицине труда",
      OccupationalMedicineJudgmentTEST2SAFE: "Заключение по медицине труда",
      OccupationalMedicineJudgmentTEST2WORK: "Заключение по медицине труда",
      PhysicalProtectionJudgment: "Заключение на лицензию охранника",
      PhysicalProtectionJudgmentTEST2ARMS: "Заключение на лицензию охранника",
      PhysicalProtectionJudgmentTEST2DRIVE: "Заключение на лицензию охранника",
      PhysicalProtectionJudgmentTEST2SAFE:
        "Заключение - работник физической охраны",
      PhysicalProtectionJudgmentTEST2WORK: "Заключение на лицензию охранника",
      ProfessionalDriverJudgment: "Заключение на должность водителя",
      ProfessionalDriverJudgmentTEST2ARMS: "Заключение на должность водителя",
      ProfessionalDriverJudgmentTEST2DRIVE: "Заключение на должность водителя",
      ProfessionalDriverJudgmentTEST2SAFE: "Заключение на должность водителя",
      ProfessionalDriverJudgmentTEST2WORK: "Заключение на должность водителя",
      PsychologicalConsultation: "Психологическая консультация",
      PsychologicalConsultationTEST2ARMS: "Психологическая консультация",
      PsychologicalConsultationTEST2DRIVE: "Психологическая консультация",
      PsychologicalConsultationTEST2SAFE: "Психологическая консультация",
      PsychologicalConsultationTEST2WORK: "Психологическая консультация",
      PsychologicalOpinion: "Психологическое заключение",
      PsychologicalOpinionTEST2ARMS: "Психологическое заключение",
      PsychologicalOpinionTEST2DRIVE: "Психологическое заключение",
      PsychologicalOpinionTEST2SAFE: "Психологическое заключение - детективы",
      PsychologicalOpinionTEST2WORK: "Психологическое заключение",
    },
    opinion: {
      breadcrumbs: "Психологическое заключение",
      breadcrumbsAppeal: "Апелляционное психологическое заключение",
      examineeData: "Данные обследуемого",
      statement:
        "НА ОСНОВАНИИ ПРОВЕДЕННОГО ПСИХОЛОГИЧЕСКОГО ОБСЛЕДОВАНИЯ ЗАКЛЮЧАЮ",
    },
    report: {
      details: {
        PESEL: "СНИЛС",
        assignDate: "Дата назначения обследования",
        endDate: "Дата завершения обследования",
        firstName: "Имя",
        idExamination: "ID обследования",
        identificationNumber: "Идентификатор",
        lastName: "Фамилия",
        name: "Название обследования",
        status: "Статус обследования",
      },
      header: {
        interval: "Выберите доверительный интервал",
        language: "Выберите язык отчета",
        recipient: "Выберите получателя",
        reportDiagnostic: "Диагностический отчет",
        reportDiagnosticCharts: "Диагностический отчет с графиками",
        reportInterpretation: "Интерпретационный отчет",
        standard: "Выберите стандарт",
      },
      statusExamination: {
        skip: "Некоторые тесты были пропущены или прерваны",
      },
    },
    snackbar: {
      save: "Документ успешно сохранен",
    },
  },
  Email: {
    bodybreak:
      '<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">\n  <p>Уважаемые господа,<br/><br/>\n  Сообщаем, что <strong>[дата, например, 30 июня 2025 года]</strong> в период с <strong>[например, 22:00 - 02:00]</strong> мы проведем плановое техническое обслуживание для обновления нашей системы.<br/>Во время работ доступ к системе Optimis может быть временно ограничен или недоступен. Просим планировать работу с системой с учетом этого периода обслуживания<br /><br />\n  \n  Приносим извинения за любые неудобства и благодарим за понимание.<br /><br />В случае вопросов просим связаться с нами<br/>email: <strong>alta@alta.pl</strong><br/>телефон:<strong>(+48) 515 131 941</strong><br /><br />\n  \n  Это сообщение было сгенерировано автоматически - пожалуйста, не отвечайте на него.\n  <br/><br>\n  С наилучшими пожеланиями,\n  Команда ALTA </p>\n  </div>',
    bodysys:
      '<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">\n  <p>Уважаемые господа,<br/><br/>\n  Сообщаем, что в праздничный период с <strong>24 декабря 2025 года</strong> по <strong>1 января 2026 года</strong> наша служба поддержки будет закрыта.<br/>Система OPTIMIS останется полностью доступной и будет работать без изменений.<br /><br />\n  \n  В случае срочных вопросов просим связаться с нами после праздничного перерыва<br/>email: <strong>alta@alta.pl</strong><br/>телефон:<strong>(+48) 515 131 941</strong><br /><br />\n  Спасибо за понимание и желаем спокойных и радостных праздников!<br /><br />\n  \n  Это сообщение было сгенерировано автоматически - пожалуйста, не отвечайте на него.\n  <br/><br>\n  С наилучшими пожеланиями,\n  Команда ALTA </p>\n  </div>',
    bodyupdate:
      '<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">\n  <p>Уважаемые господа,<br/><br/>\n  Мы рады сообщить, что мы завершили обновление системы <strong>OPTIMIS</strong>, которое состоялось [30 июня 2025 года].<br />Внесенные изменения направлены на улучшение функциональности и удобства использования.<br/><br/>Ниже мы представляем ключевые нововведения:<br /><br />\n  <ol>\n  <li><strong>Новый пользовательский интерфейс</strong>: Обновленный внешний вид и более интуитивная навигация.</li>\n  <li><strong>Улучшение производительности</strong>: Сокращенное время загрузки и более быстрая обработка данных.</li>\n  <li><strong>Новые функции</strong>: Добавлены [например, возможность персонализации настроек, интеграция с новыми инструментами, отчеты в реальном времени].</li>\n  <li><strong>Повышенная безопасность</strong>: Внедрены дополнительные меры защиты для защиты данных пользователей.</li>\n  </ol>\n  \n  Система полностью доступна, и все функции работают согласно задумке.<br/><br/>В случае вопросов или необходимости поддержки приглашаем связаться с нашей командой<br/>email: <strong>alta@alta.pl</strong><br/>телефон:<strong>(+48) 515 131 941</strong><br /><br />\n  Спасибо за доверие и приглашаем ознакомиться с новыми возможностями системы!<br /><br />\n  \n  Это сообщение было сгенерировано автоматически - пожалуйста, не отвечайте на него.\n  <br/><br>\n  С наилучшими пожеланиями,\n  Команда ALTA </p>\n  </div>',
    subjectbreak: "Техническое обслуживание",
    subjectsys: "Праздничный перерыв",
    subjectupdate: "Обновление программного обеспечения",
  },
  ExaminationAssignmentView: {
    header: "Назначить обследование",
    labels: {
      chooseExaminationType: "Выберите тип обследования",
      chooseLawBase: "Выберите правовое основание обследования",
      description: "Описание",
      legalBase: "Правовое основание обследования",
      methodologyTest2Arms:
        "TEST2ARMS - методика психологического тестирования, лицензируемая деятельность",
      methodologyTest2Drive:
        "TEST2DRIVE - методика проведения обследований водителей в рамках транспортной психологии",
      methodologyTest2Safe:
        "TEST2SAFE - методика психологического тестирования для работников охраны и детективов",
      methodologyTest2Work:
        "TEST2WORK - методика психологического тестирования в медицине труда",
      methodologyTest2SafeTlt: "TEST2SAFE",
      methodologyTest2DriveTlt: "TEST2DRIVE",
      methodologyTest2ArmsTlt: "TEST2ARMS",
      methodologyTest2WorkTlt: "TEST2WORK",
      methodologyTest2SafeDesc:
        "методика психологического тестирования для работников охраны и детективов",
      methodologyTest2DriveDesc:
        "методика проведения обследований водителей в рамках транспортной психологии",
      methodologyTest2ArmsDesc:
        "методика психологического тестирования, лицензируемая деятельность",
      methodologyTest2WorkDesc:
        "методика психологического тестирования в медицине труда",
      reason: "Цель обследования",
      suggestedTestMethods: "ПРЕДЛАГАЕМЫЕ МЕТОДИКИ",
      freeCredits: "доступные кредиты: ",
      lockedCredits: "кредиты, заблокированные в назначенных обследованиях: ",
      selectedTestCredits: "кредиты за выбранные тесты: ",
    },
    license: "Тест недоступен в приобретенной лицензии",
    testAlreadyInExamination: "Этот тест уже доступен в обследовании",
    popup: {
      checkbox: "Запомнить выбор для всех обследуемых",
      content: "Вы уверены, что хотите пропустить эти тесты?",
      header:
        "Некоторые тесты, рекомендованные для выбранной методики, были отключены.",
      headerCredits: "Внимание",
      contentCredits:
        "Невозможно выбрать тест, потому что сумма кредитов за выбранные тесты превышает количество доступных кредитов.",
    },
  },
  ExaminationList: {
    deletePopup: {
      confirmationText: "Да, я хочу удалить обследование",
      contentText:
        "После удаления обследования его невозможно будет восстановить",
      headerText: "Вы уверены, что хотите удалить обследование?",
    },
    noTestsPopup: {
      headerText: "Нет тестов для добавления",
      content:
        "В это обследование больше нельзя добавить тесты. Все тесты, доступные в вашей лицензии, уже назначены для этого обследования.",
    },
    kebabMenu: {
      delete: "Удалить обследование",
    },
    labels: {
      assign: "Назначено",
      assignDate: "Дата назначения",
      assignDateMobile: "Добавлено",
      contract: "Контракт",
      create: "Создано",
      createDate: "Дата создания",
      documentation: "Документация",
      end: "Завершено",
      endDate: "Дата завершения",
      identificator: "ID",
      interview: "Интервью",
      language: "Язык",
      nameArchiveExamination: "Название батареи",
      nameExamination: "Название обследования",
      start: "Начато",
      startDate: "Дата начала",
      testCnt: "Тесты",
      creditsCnt: "Кредиты",
      extendExamMobile: "Добавить тесты",
      recalculateExamMobile: "Пересчитать",
      examTlt: "Обследование содержит:",
      methodologyNameTlt: "методики:",
      testNameTlt: "тесты:",
    },
    toolTip: {
      contract: "Сгенерировать контракт",
      delete: "Удалить",
      documentation: "Документация",
      interview: "Интервью",
      blocked: "обследование заблокировано из-за недостатка кредитов",
      extendExam: "Добавить тесты к обследованию",
      extendExamHidden: "Функция скрыта (параметр SHOW_EXTENDED_EXAM=0)",
      recalculateExam: "Пересчитать обследование",
      recalculateExamHidden:
        "Функция скрыта (параметр SHOW_RECALCULATE_EXAM=0 или требуется администратор лаборатории)",
    },
    withoutLegalBasis: "Обследование без правового основания",
  },
  ExaminationView: {
    aimsKind: {
      aimKind_1: "Психологическое заключение - детективы",
      aimKind_10:
        "Заключение - лицензированная деятельность военного или полицейского назначения",
      aimKind_11:
        "Заключение - лицензированная деятельность гражданского назначения",
      aimKind_12:
        "Апелляционное заключение - лицензированная деятельность гражданского назначения",
      aimKind_13: "Заключение - медицина труда",
      aimKind_14:
        "Заключение - медицина труда горное дело и горноспасательные работы",
      aimKind_15: "Заключение - медицина труда лицензия машиниста",
      aimKind_16:
        "Заключение - водитель категории C1, C1+E, C, C+E, D1, D1+E, D и D+E или управление трамваем",
      aimKind_17:
        "Заключение - восстановление водительских прав категории AM, A1, A2, A, B1, B, B+E и T",
      aimKind_18:
        "Заключение - восстановление водительских прав психологические противопоказания",
      aimKind_19:
        "Заключение - продление прав категории C1, C1+E, C, C+E, D1, D1+E, D и D+E или управление трамваем",
      aimKind_20: "Заключение - послеаварийное обследование водителя",
      aimKind_21:
        "Заключение - обследование водителя после употребления алкоголя или подобных веществ",
      aimKind_22:
        "Заключение - обследование водителя после превышения 24 баллов",
      aimKind_23:
        "Заключение - обследование водителя после не менее 2 нарушений",
      aimKind_24:
        "Заключение - обследование водителя психологические противопоказания",
      aimKind_25: "Заключение - водитель спецтранспорта",
      aimKind_26:
        "Заключение - послеаварийное обследование водителя (направление старосты)",
      aimKind_27: "Заключение - выполнение обязанностей инструктора",
      aimKind_28: "Заключение - выполнение обязанностей экзаменатора",
      aimKind_29:
        "Заключение - водитель-учащийся или кандидат в среднюю школу категории C или C+E",
      aimKind_3: "Заключение - работник физической охраны",
      aimKind_30:
        "Заключение - водитель-учащийся или кандидат на профессиональный курс категории C или C+E",
      aimKind_31:
        "Заключение - профессиональный водитель по направлению работодателя",
      aimKind_32: "Заключение - самозанятый профессиональный водитель",
      aimKind_8: "Апелляционное заключение - работник физической охраны",
      aimKind_9: "Заключение - разрешение на оружие",
    },
    breadcrumbs: {
      archive: "Архивные обследования",
    },
    common: {
      unavailableInLanguageOption: "Недоступно в выбранной языковой версии.",
    },
    details: {
      createDate: "Создание обследования",
      endDate: "Завершение обследования",
      identificator: "ID обследования",
      language: "Язык",
      name: "Название обследования",
      startDate: "Дата начала обследования",
      type: "Название батареи",
    },
    header: "Документация",
    labels: {
      details: "Подробности",
      download: "Скачать",
      edit: "Редактировать",
      generate: "Сгенерировать",
      name: "Название теста",
      nameFile: "Имя файла",
      print: "Печать",
      result: "Результат",
      type: "Тип документа",
    },
    protocols: {
      language: "Язык протоколов",
      testProtocol: "Протокол теста",
      noProtocol: "Нет протоколов тестов для выбранного обследования",
    },
    tabs: {
      documentation: "Документация",
      protocols: "Протоколы",
      reports: "Отчеты",
    },
  },
  ExamineeList: {
    labels: {
      added: "Добавлено",
      allFinishExam: "Назначено / завершено",
      contract: "Контракт",
      examine: "Обследование",
      examineLastDate: "Дата последнего обследования",
      firstName: "Имя",
      folder: "Папка",
      lastName: "Фамилия",
      peselSlashIdentifier: "ПЕСЕЛ / Идентификатор",
      profile: "Посмотреть профиль",
      profileShort: "Профиль",
    },
  },
  ExamineeManagment: {
    breadcrumbs: {
      add: "Добавить субъекта",
      dashboard: "Панель пользователя",
      directories: "Картотека субъектов",
      edit: "Редактировать субъекта",
      import: "Импортировать испытуемых",
    },
    header: {
      add: "Добавить нового субъекта",
      edit: "Редактировать данные субъекта",
      editMobile: "Редактировать данные",
      import: "Импортировать испытуемых",
    },
    importExaminees: {
      collapse: "свернуть",
      errors: {
        fileReadFailed: "Ошибка чтения файла.",
        invalidPesel: "Файл импорта содержит недействительные номера PESEL.",
        invalidPeselFound:
          "Файл импорта содержит недействительные номера PESEL.",
        readFileError: "Ошибка чтения содержимого файла.",
      },
      expand: "развернуть",
      fileDesc:
        "Для импорта данных требуется файл в формате CSV. Убедитесь, что ваш файл соответствует следующим критериям:",
      fileDesc1: "1. Заголовок:",
      fileDesc10: "Фамилия.",
      fileDesc11: "pesel:",
      fileDesc12:
        "Номер PESEL. Оставьте пустым, если вы не хотите его указывать.",
      fileDesc13: "пол:",
      fileDesc14: "Пол - введите male (мужской) или female (женский).",
      fileDesc15: "день рождения:",
      fileDesc16: "Дата рождения в формате гггг-мм-дд (например, 1985-03-21).",
      fileDesc17: "Пример содержимого файла CSV:",
      downloadCsvExample: "Скачать пример CSV-файла",
      fileDesc18:
        "имя,фамилия,pesel,пол,день рождения,анонимный,электронная почта,телефон",
      fileDesc19: "Иван,Смирнов,85032112345,male,1985-03-21,0",
      fileDesc2:
        "Первая строка файла должна содержать точно следующие названия столбцов:",
      fileDesc20: "Анна,Иванова,,female,1992-07-10,0",
      fileDesc21: "Испытуемый,Анонимный,,male,1995-12-25,1",
      fileDesc22: "Объяснение примера:",
      fileDesc23: "Первая строка - это обязательный заголовок.",
      fileDesc24: "Вторая строка содержит полные данные Ивана Смирнова.",
      fileDesc25:
        "Третья строка содержит данные Анны Ивановой, но поле pesel намеренно оставлено пустым, потому что мы не будем указывать номер PESEL для этого человека.",
      fileDesc26: "Четвертая строка содержит полные данные Петра Зеленского.",
      fileDesc27:
        "Пожалуйста, подготовьте файл в соответствии с вышеприведенными инструкциями, чтобы обеспечить успешный импорт данных.",
      fileDesc28: "анонимный:",
      fileDesc29:
        "Анонимный испытуемый. 1 - анонимный испытуемый, не будет запрашиваться согласие на обработку персональных данных, не может иметь PESEL. 0 - испытуемый с персональными данными",
      fileDesc3: "имя, фамилия, pesel, пол, день рождения, анонимный",
      fileDesc30: "электронная почта:",
      fileDesc31:
        "Адрес электронной почты. Оставьте пустым, если не хотите его указывать.",
      fileDesc32: "телефон:",
      fileDesc33:
        "Номер телефона. Оставьте пустым, если не хотите его указывать.",
      fileDesc4: "2. Данные:",
      fileDesc5:
        "Каждая последующая строка должна содержать данные для одного человека, в соответствии с порядком столбцов в заголовке.",
      fileDesc6: "3. Форматирование данных:",
      fileDesc7: "имя:",
      fileDesc8: "Имя.",
      fileDesc9: "фамилия:",
      filePattern: "Формат файла импорта данных",
      importFile: "скачать файл CSV",
      noFileSelected: "-",
      saveSuccess: "Испытуемые успешно импортированы.",
      success: "Файл импорта успешно загружен.",
      tltFileSelected: "предварительный просмотр файла импорта: ",
    },
  },
  ExamineeView: {
    anonymity: "Анонимный субъект",
    drivingLicense: {
      a: "A",
      a1: "A1",
      a2: "A2",
      am: "AM",
      b: "B",
      b1: "B1",
      be: "B+E",
      c: "C",
      c1: "C1",
      c1e: "C1+E",
      ce: "C+E",
      d: "D",
      d1: "D1",
      d1e: "D1+E",
      de: "D+E",
      t: "T",
      tramwaj: "TRAMWAJ",
    },
    emptyState: {
      header: "Нет обследований, назначенных этому субъекту",
      info: "Чтобы увидеть список обследований, назначьте хотя бы одно обследование.",
    },
    kebabMenu: {
      delete: "Удалить субъекта",
      edit: "Редактировать данные субъекта",
    },
    tabs: {
      archive: "Архивные обследования",
      data: "Данные субъекта",
      examination: "Обследования",
    },
    translations: {
      basicIndustry: "базовое профессионально-техническое образование",
      basicVocational: "начальное профессиональное образование",
      female: "женщина",
      higher: "высшее образование",
      id_card: "удостоверение личности",
      lowerSecondary: "неполное среднее образование",
      male: "мужчина",
      passport: "паспорт",
      primary: "начальное образование",
      secondary: "среднее образование",
      secondaryIndustry: "среднее профессионально-техническое образование",
    },
    userData: {
      address: "Адрес",
      birthDate: "Дата рождения",
      defaultAnonFirstName: "Субъект",
      defaultAnonLastName: "Анонимный",
      drivingLicense: "Категория водительских прав",
      drivingLicenseIssuer: "Орган, выдавший водительские права",
      education: "Образование",
      email: "Адрес электронной почты",
      examineName: "Фамилия, имя, отчество",
      identificator: "Идентификатор",
      identityCard: "Документ, удостоверяющий личность",
      pesel: "Личный номер",
      phone: "Номер телефона",
      serialNumber: "Серия и номер",
      sex: "Пол",
    },
  },
  ExportResults: {
    exportActivities: "Экспорт в файл XLS",
    header: "Экспорт результатов обследований",
    headerMobile: "Экспорт результатов обследований",
    popups: {
      delete: {
        confirmationHeader: "Вы уверены, что хотите удалить файл экспорта?",
        confirmationText:
          "После удаления файла экспорта его невозможно будет восстановить.",
        confirmationCheckboxLabel: "Да, я хочу удалить файл экспорта",
      },
    },
  },
  StatsExport: {
    popups: {
      delete: {
        confirmationHeader: "Вы уверены, что хотите удалить файл статистики?",
        confirmationText:
          "После удаления файла статистики его невозможно будет восстановить.",
        confirmationCheckboxLabel: "Да, я хочу удалить файл статистики",
      },
    },
  },
  FormLabels: {
    currentPassword: "Текущий пароль",
    email: "Электронная почта",
    newPassword: "Новый пароль",
    password: "Пароль",
    pin: "ПИН-код",
  },
  FormValidation: {
    Password: {
      camelCase: "заглавную букву, строчную букву",
      length: "Минимум %lenght% символов",
      number: "цифру",
      settings: "Должен содержать:",
      spacialChar: "специальный символ",
    },
    Pin: {
      length: "Должен содержать 4 цифры",
    },
    max: "Название не может превышать 128 символов",
    required: "Это поле обязательно для заполнения",
  },
  FormValidationErrors: {
    email: "Введенное значение не является адресом электронной почты",
    required: "Это поле обязательно для заполнения",
    passwordMinLength:
      "Ваш пароль должен содержать не менее %{minLength} символов",
    passwordRequirements:
      "Ваш пароль не соответствует всем необходимым условиям",
    pinLength: "PIN-код должен состоять ровно из 4 цифр",
    pinDigitsOnly: "PIN-код может содержать только цифры",
  },
  Format: {
    ExamineeViewDateFormat: "DD.MM.YYYY",
    FormDateFormat: "D MMMM YYYY",
    ViewDateTime: "DD.MM.YYYY HH:mm",
  },
  Forms: {
    adminFields: {
      activityDetails: "Подробности",
      activityName: "действие",
      address: "Улица и номер дома",
      cin: "Регистрационный номер",
      city: "Город",
      clientId: "ID клиента",
      dateExpire: "Срок действия аккаунта",
      dateFrom: "период с",
      dateLicExpire: "Срок действия лицензии",
      dateTo: "период по",
      email: "Электронная почта",
      examineesCnt: "Обследуемые",
      firstName: "Имя",
      isActive: "Статус учетной записи",
      isStaff: "Роль",
      isSuperuser: "Пользователь с правами администратора",
      isAdmin: "Администратор",
      allowAllAccounts: "Доступ ко всем аккаунтам",
      allowAllOwnAndCreated: "Доступ к собственному аккаунту и созданным",
      lastName: "Фамилия",
      licMethodologies: "Доступные методологии",
      licTests: "Доступные тесты",
      methodologyTlt: "Методология",
      name: "Название",
      no: "нет",
      password: "Пароль",
      pin: "ПИН-код",
      postalCode: "почтовый индекс",
      pwdCamelCase: "Прописные и строчные буквы",
      pwdLength: "Длина пароля",
      pwdNumbers: "цифра",
      pwdSpecialChar: "Специальный персонаж",
      creditsLic: "Лицензия на кредиты",
      credits: "Кредиты",
      remainingCredits: "Оставшиеся кредиты для использования",
      allCredits: "Приобретённые кредиты",
      lockedCredits: "Кредиты, заблокированные в обследованиях",
      status: "статус",
      testCogTlt: "когнитивные тесты",
      testPersonTlt: "личностные тесты",
      testPsychMotorTlt: "психомоторные тесты",
      theme: "Оформление",
      tin: "ИНН",
      usersCnt: "Пользователи",
      yes: "да",
    },
    adminOptions: {
      admin: {
        admin: "администратор",
        baseuser: "регистратор",
        user: "пользователь",
      },
      status: {
        active: "активный",
        disabled: "неактивный",
      },
      theme: {
        defaultTheme: "стандартная",
        optimisTheme: "optimis",
      },
    },
    adminSnackbar: {
      email_unique_error:
        "Данный адрес электронной почты уже существует в базе данных!",
      email_wrong_error: "Указанный адрес электронной почты недействителен!",
      invalidDate: "Дата отправки не может быть раньше текущей даты",
      parametersSaved: "Параметры успешно сохранены",
      required: "Необходимо заполнить все обязательные поля.",
    },
    anonymous: "Анонимное обследование",
    emailSender: {
      dateSend: "дата отправки",
      emailSentSuccessed:
        "Сообщения сохранены и будут отправлены в запланированное время",
      emailType: "тип сообщения",
      muiRTEtextPlaceHolder: "Содержание сообщения",
      subject: "тема",
      userLang: "язык пользователя",
      user: "пользователь",
      admin: "администратор",
      staff: "регистратор",
    },
    exportResults: {
      confidenceLevel: "доверительный интервал",
      dateFrom: "дата с",
      dateTo: "дата до",
      examineeAge: "возраст",
      examineeData: "данные обследуемого",
      examineeEdu: "образование",
      examineeName: "имя и фамилия",
      examineeFolder: "название папки",
      examineeId: "ID/идентификатор",
      examineeLab: "название клиента",
      examineeSex: "пол",
      exportDeletedFileSucceeded: "Файл экспорта был удален.",
      exportSucceeded:
        "Запрос на экспорт принят. Вы получите письмо о завершении (успех или ошибка) по электронной почте.",
      filesRefresh: "обновить",
      filesToDownload: "Файлы для скачивания:",
      folders: "папки",
      genres: "области диагностики",
      noFiles: "Нет файлов для отображения.",
      norm: "нормализованные результаты",
      normStd: "нормализованные результаты - доверительные интервалы",
      norms: "норма",
      protocol: "интервью",
      psychLabs: "клиенты",
      raw: "сырые результаты",
      rawStd: "сырые результаты - доверительные интервалы",
      resultsData: "результаты",
      tests: "тесты",
    },
    statsExport: {
      exportSucceeded:
        "Запрос на экспорт статистики принят. Вы получите письмо о завершении (успех или ошибка) по электронной почте.",
      deletedFileSucceeded: "Файл статистики удалён.",
      filesToDownload: "Файлы статистики для скачивания:",
      noFiles: "Нет файлов статистики для отображения.",
      filesRefresh: "обновить",
      rangeRequired: "Выберите диапазон дат (с и по).",
    },
    extraFields: "Дополнительные данные",
    fields: {
      additionalInfo: "Дополнительная информация",
      address: "Улица и номер дома",
      age: "Возраст",
      appealAuthority: "Название учреждения",
      appealDeadline: "Дата",
      birthDate: "Дата рождения",
      city: "Город",
      country: "Страна",
      date: "Дата",
      diffrentIdentificationNumber: "Другой идентификатор",
      directory: "Папка",
      documentDate: "Дата выдачи",
      drivingLicense: "Категория водительских прав",
      drivingLicenseIssuer: "Орган выдачи водительских прав",
      education: "Образование",
      email: "Адрес электронной почты",
      examineeRegistryId: "Номер в реестре обследуемых",
      identificationNumber: "Личный номер",
      identityDocumentNumber: "Серия и номер",
      identityDocumentType: "Документ, удостоверяющий личность",
      institutionName: "Название учреждения",
      interval: "Выберите доверительный интервал",
      judgmentNumber: "Номер решения",
      lang: "Язык",
      languageReport: "Выберите язык отчета",
      legalBasis: "Правовое основание обследования",
      months: "месяцы",
      name: "Имя",
      nextExamination: "Дата следующего обследования",
      phone: "Номер телефона",
      postalCode: "Почтовый индекс",
      recipient: "Выберите получателя",
      sex: "Пол",
      standard: "Выберите стандарт",
      surname: "Фамилия",
      year: "Год",
      years: "Лет",
      testName: "Название теста",
      credits: "Цена клиента",
      creditsGlobal: "Цена",
      value: "Значение",
      values: "Значения",
    },
    options: {
      activities: {
        ADMIN_CHANGE_LAB_ID: "Администратор вошел в учетную запись клиента",
        ADMIN_LICENCE_ADDED: "Добавлена лицензия для учетной записи клиента",
        ADMIN_LICENCE_CHANGED: "Изменена лицензия учетной записи клиента",
        ADMIN_LICENCE_DELETED: "Удалена лицензия учетной записи клиента",
        ADMIN_LOGGED_IN: "Администратор вошел в систему",
        ADMIN_LOGGED_OUT: "Администратор вышел из системы",
        ADMIN_PSYCHOLOGICAL_LAB_ADDED: "Добавлена учетная запись клиента",
        ADMIN_PSYCHOLOGICAL_LAB_CHANGED:
          "Изменены данные учетной записи клиента",
        ADMIN_PSYCHOLOGICAL_LAB_DELETED: "Удалена учетная запись клиента",
        ADMIN_USER_ADDED: "Добавлен пользователь к учетной записи клиента",
        ADMIN_USER_CHANGED:
          "Изменены данные пользователя учетной записи клиента",
        ADMIN_USER_DELETED: "Удален пользователь из учетной записи клиента",
        ALL: "все",
        ALL_ITEMS: "Все действия",
        APP_REGISTRATION: "Регистрация приложения",
        AUDIT_ERROR: "Ошибка журнала активности",
        CONSOLE_PIN_VERIFICATION: "Проверка ПИН-кода на консоли пользователя",
        CONTRACT_DOWNLOADED: "Контракт скачан",
        DIRECTORY_CREATED: "Папка создана",
        DIRECTORY_DELETED: "Папка удалена",
        DIRECTORY_NAME_CHANGED: "Название папки изменено",
        EXAMINATION_ASSIGNED: "Обследование назначено",
        EXAMINATION_DELETED: "Обследование удалено",
        EXAMINATION_PROTOCOLS_ZIP_DOWNLOADED:
          "Протоколы обследования ZIP скачаны",
        EXAMINATION_PROTOCOL_DOWNLOADED: "Протокол обследования скачан",
        EXAMINATION_REPORT_DOWNLOADED: "Документы отчета скачаны",
        EXAMINATION_STARTED: "Обследование начато",
        EXAMINATION_TERMINATED: "Обследование завершено",
        EXAMINEE_ADDED: "Субъект добавлен",
        EXAMINEE_DATA_CHANGE: "Данные субъекта изменены",
        EXAMINEE_DELETED: "Данные субъекта удалены",
        EXAMINEE_MOVED_TO_DIFFERENT_DIRECTORY:
          "Данные субъекта перемещены в другую папку",
        IMPORT_EXAMINEE: "Импорт обследуемых",
        INTERVIEW_CHANGED: "Интервью изменено",
        INTERVIEW_DOWNLOADED: "Интервью скачано",
        PASSWORD_CHANGE: "Смена пароля",
        PASSWORD_CHANGE_EXPIRED: "Смена пароля после истечения срока действия",
        PASSWORD_CHANGE_REQUEST: "Запрос на смену пароля",
        PIN_CHANGE: "Смена ПИН-кода",
        SAVE_AGREEMENTS:
          "Сохранение согласий на обследование и обработку данных",
        TEST_RESULT_SUBMITTED: "Результаты теста отправлены",
        TEST_SKIPPED: "Тест пропущен на консоли",
        USER_LOGGED_IN: "Пользователь вошел в систему",
        USER_LOGGED_OUT: "Пользователь вышел из системы",
        ADMIN_PRICELIST_CHANGED: "Изменение глобального прейскуранта",
        ADMIN_LAB_ANONYMIZED: "Анонимизация данных",
        EXPORT_RESULTS_GENERATED: "Экспорт результатов сгенерирован",
        EXPORT_FILE_DOWNLOADED: "Файл экспорта результатов скачан",
        EXPORT_FILE_DELETED: "Файл экспорта результатов удален",
        LAB_PARAMS_BULK_UPDATED: "Обновление параметров лаборатории",
        EXAMINATION_DOCUMENT_DOWNLOADED: "Документ обследования скачан",
        EXAMINATION_DOCUMENT_CHANGED: "Документ обследования изменен",
        EXAMINATION_EXTENDED: "Обследование расширено новыми тестами",
        IMPORT_EXAMINEE_AND_ASSIGNED_EXAMINATION:
          "Импорт обследуемых и назначение обследований",
        TEST_TYPE_CREDITS_UPDATED: "Изменение прейскуранта тестов для клиента",
        LICENSE_CREDITS_DEDUCTED:
          "Списание кредитов при сохранении результатов теста",
      },
      activitiesStatus: {
        ok: "ок",
        server_error: "ошибка сервера",
        user_error: "ошибка пользователя",
      },
      bool: {
        false: "Нет",
        true: "Да",
      },
      country: {
        afghanistan: "Afghanistan",
        albania: "Albania",
        algeria: "Algeria",
        americanSamoa: "American Samoa",
        andorra: "Andorra",
        angola: "Angola",
        anguilla: "Anguilla",
        antarctica: "Antarctica",
        antiguaAndBarbuda: "Antigua and Barbuda",
        argentina: "Argentina",
        armenia: "Armenia",
        aruba: "Aruba",
        australia: "Australia",
        austria: "Austria",
        azerbaijan: "Azerbaijan",
        bahamas: "Bahamas",
        bahrain: "Bahrain",
        bangladesh: "Bangladesh",
        barbados: "Barbados",
        belarus: "Belarus",
        belgium: "Belgium",
        belize: "Belize",
        benin: "Benin",
        bermuda: "Bermuda",
        bhutan: "Bhutan",
        bolivia: "Bolivia",
        bonaireSintEustatiusAndSaba: "Bonaire, Sint Eustatius and Saba",
        bosniaAndHerzegovina: "Bosnia and Herzegovina",
        botswana: "Botswana",
        bouvetIsland: "Bouvet Island",
        brazil: "Brazil",
        britishIndianOceanTerritory: "British Indian Ocean Territory",
        bruneiDarussalam: "Brunei Darussalam",
        bulgaria: "Bulgaria",
        burkinaFaso: "Burkina Faso",
        burundi: "Burundi",
        cambodia: "Cambodia",
        cameroon: "Cameroon",
        canada: "Canada",
        capeVerde: "Cape Verde",
        caymanIslands: "Cayman Islands",
        centralAfricanRepublic: "Central African Republic",
        ceuta: "Ceuta",
        chad: "Chad",
        chile: "Chile",
        china: "China",
        christmasIsland: "Christmas Island",
        cocosIslands: "Cocos (Keeling) Islands",
        colombia: "Colombia",
        comoros: "Comoros",
        congo: "Congo (Rep.)",
        cookIslands: "Cook Islands",
        costaRica: "Costa Rica",
        coteDivoire: "Cote D’Ivoire",
        croatia: "Croatia",
        cuba: "Cuba",
        curacao: "Curaçao",
        cyprus: "Cyprus",
        czechRepublic: "Czechia",
        democraticRepublicOfTheCongo: "Congo (Dem. Rep.)",
        denmark: "Denmark",
        djibouti: "Djibouti",
        dominica: "Dominica",
        dominicanRepublic: "Dominican Republic",
        ecuador: "Ecuador",
        egypt: "Egypt",
        elSalvador: "El Salvador",
        equatorialGuinea: "Equatorial Guinea",
        eritrea: "Eritrea",
        estonia: "Estonia",
        ethiopia: "Ethiopia",
        falklandIslands: "Falkland Islands (Malvinas)",
        faroeIslands: "Faroe Islands",
        fiji: "Fiji",
        finland: "Finland",
        france: "France",
        frenchPolynesia: "French Polynesia",
        frenchSouthernTerritories: "French Southern Territories",
        gabon: "Gabon",
        gambia: "Gambia",
        georgia: "Georgia",
        germany: "Germany",
        ghana: "Ghana",
        gibraltar: "Gibraltar",
        greece: "Greece",
        greenland: "Greenland",
        grenada: "Grenada",
        guam: "Guam",
        guatemala: "Guatemala",
        guinea: "Guinea",
        guineaBssau: "Guinea-Bissau",
        guyana: "Guyana",
        haiti: "Haiti",
        heardAndMcdonaldIslands: "Heard and McDonald Islands",
        honduras: "Honduras",
        hongKong: "Hong Kong",
        hungary: "Hungary",
        iceland: "Iceland",
        india: "India",
        indonesia: "Indonesia",
        iran: "Iran, Islamic Republic of",
        iraq: "Iraq",
        ireland: "Ireland",
        israel: "Israel",
        italy: "Italy",
        jamaica: "Jamaica",
        japan: "Japan",
        jordan: "Jordan",
        kazakhstan: "Kazakhstan",
        kenya: "Kenya",
        kiribati: "Kiribati",
        koreaNorth: "Korea, Democratic People’s Republic of",
        kosovo: "Kosovo",
        kuwait: "Kuwait",
        kyrgyztan: "Kyrgyztan",
        lao: "Lao, People’s Democratic Republic of",
        latvia: "Latvia",
        lebanon: "Lebanon",
        lesotho: "Lesotho",
        liberia: "Liberia",
        libyan: "Libyan Arab Jamahiriya",
        liechtenstein: "Liechtenstein",
        lithuania: "Lithuania",
        luxembourg: "Luxembourg",
        macao: "Macao",
        madagascar: "Madagascar",
        malawi: "Malawi",
        malaysia: "Malaysia",
        maldives: "Maldives",
        mali: "Mali",
        malta: "Malta",
        marshallIslands: "Marshall Islands",
        mauritania: "Mauritania",
        mauritius: "Mauritius",
        mayotte: "Mayotte",
        melilla: "Melilla",
        mexico: "Mexico",
        micronesia: "Micronesia, Federal States of",
        moldova: "Moldova, Republic of",
        mongolia: "Mongolia",
        montenegro: "Montenegro",
        montserrat: "Montserrat",
        morocco: "Morocco",
        mozambique: "Mozambique",
        myanmar: "Myanmar",
        namibia: "Namibia",
        nauru: "Nauru",
        nepal: "Nepal",
        netherlands: "Netherlands",
        newCaledonia: "New Caledonia",
        newZealand: "New Zealand",
        nicaragua: "Nicaragua",
        niger: "Niger",
        nigeria: "Nigeria",
        niue: "Niue",
        norfolk: "Norfolk Island",
        northernMacedonia: "North Macedonia",
        northernMarianaIslands: "Northern Mariana Islands",
        norway: "Norway",
        oman: "Oman",
        pakistan: "Pakistan",
        palau: "Palau",
        palestinian: "Palestinian Territory, Occupied",
        panama: "Panama",
        papuaNewGuinea: "Papua New Guinea",
        paraguay: "Paraguay",
        peru: "Peru",
        philippines: "Philippines",
        pitcairn: "Pitcairn",
        poland: "Poland",
        portugal: "Portugal",
        qatar: "Qatar",
        romania: "Romania",
        russia: "Russian Federation",
        rwanda: "Rwanda",
        saintBarthelemy: "Saint Barthelemy",
        samoa: "Samoa",
        sanMarino: "San Marino",
        saoTomeAndPrincipe: "Sao Tome and Principe",
        saudiArabia: "Saudi Arabia",
        senegal: "Senegal",
        serbia: "Serbia",
        seychelles: "Seychelles",
        sierraLeone: "Sierra Leone",
        singapore: "Singapore",
        sintMaartenDutch: "Sint Maarten (Dutch part)",
        slovakia: "Slovakia",
        slovenia: "Slovenia",
        solomonIslands: "Solomon Islands",
        somalia: "Somalia",
        southAfrica: "South Africa",
        southGeorgiaAndSouthSandwichIslands:
          "South Georgia and South Sandwich Islands",
        southKorea: "Korea, Republic of",
        southSudan: "South Sudan",
        spain: "Spain",
        sriLanka: "Sri Lanka",
        stHelena: "St.Helena",
        stKittsandAndNevis: "St.Kittsand and Nevis",
        stLucia: "St.Lucia",
        stPierreAndMiquelon: "St Pierre and Miquelon",
        stVincentAndTheGrenadines: "St Vincent and the Grenadines",
        sudan: "Sudan",
        suriname: "Suriname",
        swaziland: "Swaziland",
        sweden: "Sweden",
        switzerland: "Switzerland",
        syrian: "Syrian Arab Republic",
        taiwan: "Taiwan, Provice of China",
        tajikistan: "Tajikistan",
        tanzania: "Tanzania, United Republic of.",
        thailand: "Thailand",
        timorLeste: "Timor Leste",
        togo: "Togo",
        tokelau: "Tokelau",
        tonga: "Tonga",
        trinidadAndTobago: "Trinidad and Tobago",
        tunisia: "Tunisia",
        turkey: "Turkey",
        turkmenistan: "Turkmenistan",
        turksAndCaicosIslands: "Turks and Caicos Islands",
        tuvalu: "Tuvalu",
        uganda: "Uganda",
        ukraine: "Ukraine",
        unitedArabEmirates: "United Arab Emirates",
        unitedKingdom: "United Kingdom",
        unitedKingdomNorthernIreland: "United Kingdom (Northern Ireland)",
        unitedStatesOfAmerica: "United States of America",
        uruguay: "Uruguay",
        usMinorOutlyingIslands: "U.S. Minor Outlying Islands",
        uzbekistan: "Uzbekistan",
        vanuatu: "Vanuatu",
        vatican: "Vatican City State",
        venezuela: "Venezuela",
        vietnam: "Vietnam",
        virginIslandsBritish: "Virgin Islands (British)",
        virginIslandsUSA: "Virgin Islands (USA)",
        wallisAndFutuna: "Wallis and Futuna Islands",
        westernSahara: "Western Sahara",
        yemen: "Yemen",
        zambia: "Zambia",
        zimbabwe: "Zimbabwe",
      },
      education: {
        basicIndustry: "Базовое профессионально-техническое",
        basicVocational: "Начальное профессиональное",
        higher: "Высшее",
        lowerSecondary: "Неполное среднее",
        primary: "Начальное",
        secondary: "Среднее",
        secondaryIndustry: "Среднее профессионально-техническое",
      },
      emailType: {
        break: "техническое обслуживание",
        system: "информация",
        update: "обновление",
      },
      exportResultConfidenceLevel: {
        item_85: "0.85",
        item_9: "0.9",
        item_95: "0.95",
        item_99: "0.99",
      },
      genres: {
        cognitive: "когнитивные и интеллектуальные процессы",
        personality: "личность",
        psychomotor: "психомоторика",
      },
      identityDocument: {
        idCard: "Удостоверение личности",
        passport: "Паспорт",
      },
      lang: {
        english: "Английский",
        espaniol: "Испанский",
        mexico: "Мексиканский испанский",
        polish: "Польский",
        russian: "Русский",
        ukrain: "Украинский",
      },
      languagesDocumentation: {
        en: "английский",
        pl: "польский",
      },
      norms: {
        norm_1: "OPT_1.0.PL",
        norm_2: "OPT_1.0.UA",
        norm_3: "OPT_1.0.RU",
      },
      recipient: {
        examinee: "Обследуемый",
        psychologist: "Психолог",
        specialist: "Специалист",
      },
      sex: {
        female: "Женщина",
        male: "Мужчина",
      },
    },
    passwordFields: "Настройки пароля",
    pwdFields: "Политика паролей",
    requiredFields: "Обязательные данные",
    selectAll: "выбрать все",
    snackbar: {
      peselLength: "Личный номер должен состоять из 11 цифр",
      peselNumber: "Личный номер должен содержать только цифры",
      required: "Необходимо заполнить все обязательные поля.",
    },
  },
  HelpDocs: {
    contractFileName1: "/help-documents/pl-pl/kontrakt_psychologiczny_2024.pdf",
    contractFileName2:
      "/help-documents/pl-pl/kontrakt_psychologiczny_ru_2024.pdf",
    contractFileName3:
      "/help-documents/pl-pl/kontrakt_psychologiczny_ua_2024.pdf",
    contractFileName4:
      "/help-documents/pl-pl/polityka_ochrony_danych_osobowych_klauzula_informacyjna_2024.pdf",
    contractName1: "Психологический контракт 2024",
    contractName2: "Психологический контракт RU 2024",
    contractName3: "Психологический контракт UA 2024",
    contractName4:
      "Политика защиты персональных данных - Информационная оговорка 2024",
    contractTitle: "Контракты",
    handbookFileName1:
      "/help-documents/pl-pl/charakterystyka_obszarow_diagnozy.pdf",
    handbookFileName2: "/help-documents/pl-pl/testy_psychomotoryczne.pdf",
    handbookFileName3: "/help-documents/pl-pl/testy_poznawcze.pdf",
    handbookFileName4: "/help-documents/pl-pl/testy_osobowosci.pdf",
    handbookFileName5: "/help-documents/pl-pl/katalog_testow_03_2024.pdf",
    handbookName1: "Характеристика областей диагностики",
    handbookName2: "Психомоторные тесты",
    handbookName3: "Когнитивные тесты",
    handbookName4: "Тесты личности",
    handbookName5: "Каталог тестов 03-2024",
    handbookTitle: "Справочник и каталог тестов",
    modulesFileName1: "/help-documents/pl-pl/sytuacja_zdrowotna.pdf",
    modulesFileName10:
      "/help-documents/pl-pl/psychologia_transportu_kierowanie pojazdami_mtd_IV.pdf",
    modulesFileName2: "/help-documents/pl-pl/sytuacja_spoleczna_i_rodzinna.pdf",
    modulesFileName3: "/help-documents/pl-pl/obserwacja.pdf",
    modulesFileName4: "/help-documents/pl-pl/detektywi_ochrona_bron_mtd_I.pdf",
    modulesFileName5: "/help-documents/pl-pl/koncesja_mtd_II.pdf",
    modulesFileName6: "/help-documents/pl-pl/medycyna_pracy_mtd_III.pdf",
    modulesFileName7: "/help-documents/pl-pl/kierowcy_sluzbowi_mtd_III.pdf",
    modulesFileName8: "/help-documents/pl-pl/praca_wysokosc_mtd_III.pdf",
    modulesFileName9: "/help-documents/pl-pl/wozki_widlowe_mtd_III.pdf",
    modulesName1: "Состояние здоровья",
    modulesName10:
      "Транспортная психология управление транспортными средствами MTD IV",
    modulesName2: "Социальная и семейная ситуация",
    modulesName3: "Наблюдение",
    modulesName4: "Детективы защита оружие MTD I",
    modulesName5: "Лицензия MTD II",
    modulesName6: "Медицина труда MTD III",
    modulesName7: "Служебные водители MTD III",
    modulesName8: "Работа на высоте MTD III",
    modulesName9: "Погрузчики MTD III",
    modulesTitle: "Модули интервью",
    policyName1:
      "Политика защиты персональных данных - Информационная оговорка 2024",
    policyTitle1: "Политика защиты персональных данных",
  },
  Helpdesk: {
    contact: "Контакты",
    text1:
      "Отчеты об ошибках или неправильной работе системы следует отправлять электронной почтой на адрес: ",
    text2: "optimis@alta.pl",
    text3: "Техническая поддержка доступна в рабочие дни",
    text4: "в часах с 8:00 до 16:00",
    documents: {
      header: "Справочные документы",
      labels: {
        download: "Скачать",
        name: "Название документа",
      },
    },
    header: "Помощь",
    help: "Удаленная поддержка",
    mobile: "моб.",
    phoneNo: "тел.",
    subheader: "Служба поддержки",
    phoneNo1: "(+48) 32 249 50 40",
    phoneNo2: "(+48) 515 131 941",
    phoneNo3: "",
    emailValue: "",
  },
  Interview: {
    header: "Интервью",
    hours: "Часов",
    inputAdditionalInformation: "Введите дополнительную информацию",
    inputHoursOfWork: "Введите количество рабочих часов за последние сутки",
    months: "Месяцев",
    questions: {
      methodologies: {
        currentPsychophysicalState: {
          headers: {
            criticalEvents: "Критические события",
            currentState: "Текущее психофизическое состояние",
          },
          questionExtendedTexts: {
            commonText: "Опишите обстоятельства этого события/ситуации",
          },
          questionTexts: {
            question1:
              "Употреблял ли обследуемый алкоголь в течение последних 48 часов?",
            question10: "Обращение за помощью к:",
            question10a: "a. психологу",
            question10b: "b. психиатру",
            question10c: "c. неврологу",
            question11: "Справка об инвалидности",
            question12: "Проблемы, связанные с употреблением алкоголя",
            question13: "Пребывание в вытрезвителе",
            question14:
              "Употребление одурманивающих/психоактивных веществ/наркотиков",
            question15:
              "Предложения врача или близкого человека обратиться за лечением из-за нервозности, рассеянности или проблем с памятью или ориентацией",
            question2:
              "Работал ли обследуемый профессионально в течение последней или предпоследней ночи?",
            question3: "Количество рабочих часов за последние сутки",
            question4: "Травма головы, требующая медицинской помощи",
            question5: "Потеря сознания",
            question6: "Пребывание в больнице",
            question7:
              "Было ли когда-либо или есть в настоящее время лечение/был ли когда-либо диагноз следующих заболеваний:",
            question7a:
              "a. заболевания пищеварительной системы (язва желудка или двенадцатиперстной кишки, нарушения функции кишечника и т.д.)",
            question7b:
              "b. заболевания сердца и системы кровообращения (ишемическая болезнь, повышенное артериальное давление)",
            question7c:
              "c. нарушения слуха или зрения (за исключением ношения корректирующих очков)",
            question7d: "d. диабет",
            question7e: "e. эпилепсия",
            question7f:
              "f. психические заболевания (депрессия, невроз, психиатрическое лечение (уточнить о психиатрическом лечении близкого члена семьи)",
            question8:
              "Регулярный прием лекарств (уточнить, знает ли о побочных эффектах и спросить о других лекарствах, влияющих на психические функции)",
            question9: "Проблемы со сном",
          },
        },
        detectivesSecurityGuardsAndWeaponPermits: {
          questionAnswers: {
            question1a: "в профессиональных целях (детектив, охранник)",
            question1b: "в охотничьих целях",
            question1c: "в спортивных целях",
            question1d: "для личного пользования",
            question1e: "для музейных, памятных, научных целей",
            question1f: "другое",
          },
          questionTexts: {
            question1: "Основные цели использования оружия:",
            question1g: "Какие?",
            question2:
              "Имело ли место когда-либо применение оружия или других средств прямого принуждения?",
            question3: "Как часто применялось оружие за последние 5 лет?",
          },
        },
        drivingVehicles: {
          headers: {
            drivingCharacteristics: "Характеристика маршрутов",
          },
          questionAnswers: {
            question13a: "как виновник/соучастник",
            question13b: "как потерпевший",
            question13c: "не применимо",
            question14a: "как виновник/соучастник",
            question14b: "как потерпевший",
            question14c: "не применимо",
            question15a: "перевозка опасных материалов",
            question15b: "перевозка пассажиров",
            question15c: "инструктор по вождению",
            question15d: "экзаменатор по вождению",
            question15e: "отсутствуют",
            question3a: "менее 3 000 км в год",
            question3b: "между 3 000 – 15 000 км в год",
            question3c: "между 15 000 - 70 000 км в год",
            question3d: "более 70 000 км в год",
            question3e: "затрудняюсь ответить",
            question4a: "менее 5 часов в неделю",
            question4b: "между 5 - 15 часов в неделю",
            question4c: "между 15 - 40 часов в неделю",
            question4d: "более 40 часов в неделю",
            question4e: "затрудняюсь ответить",
            question5a: "езжу преимущественно на коротких маршрутах",
            question5b: "езжу преимущественно на длинных маршрутах",
            question5c: "езжу как на длинных, так и на коротких маршрутах",
            question6a: "езжу обычно по постоянным маршрутам",
            question6b: "езжу чаще всего по разным маршрутам",
            question7a: "езжу чаще всего ночью",
            question7b: "езжу обычно днем",
            question7c: "езжу как днем, так и ночью",
            question8a: "езжу в основном самостоятельно без сменщика",
            question8b: "езжу чаще всего со сменщиком",
            question9a: "езжу в основном по городу",
            question9b: "езжу в основном за городом",
          },
          questionTexts: {
            question1: "Общий стаж вождения",
            question10: "Приостановка или лишение водительских прав",
            question11: "Заключение о неспособности к вождению",
            question12: "Наказание за нарушение ПДД или дорожное преступление",
            question13: "Участие в качестве водителя в автомобильной аварии",
            question14: "Участие в качестве водителя в дорожном происшествии",
            question15: "Дополнительные квалификации и лицензии",
            question2: "Стаж работы водителем",
            question3: "Годовой пробег",
            question4: "Количество часов за рулем",
            question5: "Длина маршрутов",
            question6: "Разнообразие маршрутов",
            question7: "Время суток",
            question8: "Сменный водитель",
            question9: "Территория",
          },
        },
        licensedActivity: {
          questionTexts: {
            question1:
              "Общий стаж работы в учреждении, занимающемся лицензированной деятельностью",
            question2: "Должность/выполняемые обязанности",
            question3:
              "Стаж работы в текущей должности в учреждении, занимающемся лицензированной деятельностью",
            question4a: "Участие в происшествии на рабочем месте",
            question4b:
              "Каковы были причины, последствия происшествия - был ли нанесен ущерб имуществу, здоровью?",
          },
        },
        observation: {
          questionAnswers: {
            question1a:
              "Устанавливает очень хороший контакт с собеседником; поддерживает зрительный контакт; ведет себя уверенно и естественно, не позволяет вывести себя из равновесия или проявить нетерпение, ведет себя спонтанно и естественно.",
            question1b:
              "Устанавливает контакт с собеседником; поддерживает зрительный контакт; ведет себя естественно, хотя заметны признаки некоторого волнения.",
            question1c:
              "Ведет себя отстраненно, избегает зрительного контакта; ведет себя неестественно, малые раздражители вызывают потерю равновесия, видны явные признаки нервозности и нетерпения.",
            question2a:
              "Формулирует высказывания, используя правильный язык, строит четкие, понятные предложения, поддерживает логическую структуру речи, использует богатый словарный запас.",
            question2b:
              "Формулирует высказывания правильно, в целом поддерживает их логическую структуру; словарный запас средний, но правильный.",
            question2c:
              "Формулирует короткие, формальные высказывания, часто бессвязные или неясные; использует неправильные фразы и формулировки; предложения очень простые, словарный запас очень бедный, встречаются грамматические ошибки.",
            question3a:
              "Наблюдается очень веселое, оптимистичное настроение; удовлетворенность собой и своей жизненной ситуацией.",
            question3b:
              "Наблюдается умеренное настроение, довольно позитивное отношение и в целом оптимистичный взгляд в будущее.",
            question3c:
              "Наблюдаются непропорционально сильные эмоциональные реакции, явная склонность к пессимистическому восприятию мира; проявление неудовлетворенности.",
            question4a:
              "В ходе обследования адекватно контролирует свое поведение и эмоции, адекватно приспосабливается к возникающим обстоятельствам.",
            question4b:
              "В ходе обследования в целом контролирует свое поведение и эмоции; чаще всего адекватно реагирует на возникающие обстоятельства.",
            question4c:
              "В ходе обследования наблюдаются трудности с контролем поведения и эмоций; появляются неадекватные поведение или эмоции.",
          },
          questionTexts: {
            question1: "Контакт с собеседником",
            question2: "Язык и риторика",
            question3: "Настроение и отношение",
            question4: "Самообладание и контроль поведения и эмоций",
          },
        },
        occupationalMedicine: {
          headers: {
            companyCarDrivers: "Водители служебных автомобилей",
            forkliftOperators: "Операторы погрузчиков",
            minersAndMinerLifeguards: "Шахтеры и горноспасатели",
            trainDriver: "Машинисты",
            workCourseInformation: "История профессиональной карьеры",
            workInformation: "Информация о профессиональной деятельности",
            workingAtHeights: "Работа на высоте",
          },
          questionAnswers: {
            question13a: "менее 3 000 км в год",
            question13b: "между 3 000 – 15 000 км в год",
            question13c: "между 15 000 - 70 000 км в год",
            question13d: "более 70 000 км в год",
            question13e: "затрудняюсь ответить",
            question14a: "менее 5 часов в неделю",
            question14b: "между 5 - 15 часов в неделю",
            question14c: "между 15 - 40 часов в неделю",
            question14d: "более 40 часов в неделю",
            question14e: "затрудняюсь ответить",
            question18a: "как виновник/соучастник",
            question18b: "как потерпевший",
            question18c: "не применимо",
            question19a: "как виновник/соучастник",
            question19b: "как потерпевший",
            question19c: "не применимо",
            question5a: "Монотонная работа",
            question5b: "Постоянный большой поток информации",
            question5c: "Высокий уровень шума",
            question5d:
              "Работа с высокой психологической нагрузкой (ответственность и принятие решений)",
            question5e: "Ионизирующее излучение",
            question5f: "Химические факторы",
            question5g: "Другие",
          },
          questionTexts: {
            question1: "Полученная профессия",
            question10: "Обследуемый попал в производственную аварию",
            question10a: "Когда? Какими были последствия для здоровья?",
            question11: "Установлена инвалидность",
            question11a:
              "По какой причине? С какого времени? До какого времени?",
            question12: "Общий стаж вождения",
            question13: "Годовой пробег",
            question14: "Количество часов за рулем",
            question15: "Заключение о неспособности к вождению",
            question16: "Приостановка или лишение водительских прав",
            question17: "Наказание за нарушение ПДД или дорожное преступление",
            question18: "Участие в качестве водителя в автомобильной аварии",
            question19: "Участие в качестве водителя в дорожном происшествии",
            question2: "Текущая профессия",
            question20: "Наличие допуска к работе на высоте",
            question21:
              "Выполнение работ на высоте (если да, уточнить, сколько метров над землей)",
            question22: "Субъективное ощущение страха при нахождении на высоте",
            question23: "Несчастный случай при работе на высоте",
            question23a: "Был ли причинен ущерб имуществу или здоровью?",
            question24: "Наличие допуска к работе оператором погрузчика",
            question25:
              "Выполнение работ, связанных с обслуживанием и управлением погрузчиком",
            question26:
              "Несчастный случай при обслуживании или управлении погрузчиком",
            question26a: "Был ли причинен ущерб имуществу или здоровью?",
            question3: "Место работы / учебы",
            question4: "Должность / выполняемые обязанности",
            question5:
              "Постоянные вредные/обременительные факторы на рабочем месте",
            question5f: "Какие?",
            question5g: "Какие?",
            question6: "Общий стаж работы",
            question7: "Стаж работы в текущей должности",
            question8: "Диагностировано профессиональное заболевание",
            question8a: "Когда? По какой причине?",
            question9: "Назначено пенсионное пособие",
            question9a:
              "По какой причине? С какого времени? До какого времени?",
          },
        },
        socialAndFamilySituation: {
          questionTexts: {
            question1:
              "Серьезный конфликт или проблема, связанная с работой (например, несчастный случай на работе, выговор, трудовой суд, дисциплинарное увольнение, моббинг)",
            question2:
              "Проблемы в период обучения (например, повторение класса, исключение из школы, приостановление прав учащегося)",
            question3:
              "Серьезный семейный конфликт или проблемы в личных ситуациях (например, судебные дела, участие в драках, можно уточнить о семейном положении, детях)",
            question4:
              "Ситуация прямой угрозы жизни (например, пожар, наводнение и другие катастрофы)",
            question5:
              "Опыт физического насилия в отношении себя (например, нападение, кража, избиение)",
            question6:
              "Участие в общественных организациях (например, волонтерство)",
            question7: "Судимость (например, получение штрафов, приговор суда)",
          },
        },
      },
      questionAnswers: {
        no: "нет",
        yes: "да",
      },
      questionTexts: {
        describeTheCircumStancesOfUsage: "Опишите обстоятельства использования",
        forHowLong: "До какого времени?",
        sinceWhen: "С какого времени?",
        whatAreTheConsequences: "Какие были последствия для здоровья?",
        when: "Когда?",
        why: "По какой причине?",
      },
    },
    tabs: {
      currentPsychophysicalState: "Состояние здоровья",
      drivingVehicles: "Управление транспортными средствами",
      licensedActivities: "Лицензированная деятельность",
      observation: "Наблюдение",
      occupationalMedicine: "Профессиональная медицина",
      securityAndDetectives: "Охранные и детективные услуги",
      socialAndFamilySituation: "Социальная и семейная ситуация",
    },
    years: "Лет",
  },
  Language: {
    pl: "Польский",
    ru: "Русский",
    uk: "Украинский",
  },
  Login: {
    Access_denied: "Доступ запрещен",
    Captcha_error:
      "Ошибка при заполнении captcha. Пожалуйста, попробуйте снова.",
    Instance_configured_incorrectly:
      "Ошибка конфигурации системы. Сообщите о проблеме в техническую поддержку.",
    Laboratory_is_inactive_or_deleted: "Неактивный аккаунт клиента",
    Laboratory_account_has_expired:
      "Вход невозможен — срок действия аккаунта истёк.",
    No_recaptcha_token_provided:
      "Ошибка recaptcha. Сообщите о проблеме в техническую поддержку.",
    User_account_has_been_deleted: "Учетная запись пользователя была удалена",
    User_account_is_not_active: "Неактивная учетная запись пользователя",
    Validation_failed: "Неверный адрес электронной почты или пароль.",
    adminHeader: "ПАНЕЛЬ АДМИНИСТРАТОРА",
    error: "Неверный адрес электронной почты или пароль.",
    header: "ВХОД",
    reset: "Сбросить пароль",
    warning: "Включен CAPS LOCK",
  },
  Onboarding: {
    errorText:
      "При установке пароля произошла ошибка, пожалуйста, попробуйте позже.",
    setNewPasswordInfo:
      "Введите пароль, который вы будете использовать для входа в систему.",
    setPasswordFormLabel: "Установить пароль",
    setPinFormLabel: "Установите свой ПИН-код",
    setPinInfo:
      "Введите ПИН-код, который вы будете использовать для входа в консоль психолога.",
    success:
      "Ваши пароль и ПИН-код сохранены. Теперь вы можете впервые войти в приложение, используя свой адрес электронной почты и пароль.",
    successTitle: "Пароль и ПИН-код установлены",
  },
  Pagination: {
    outOf: "из",
  },
  PasswordExpired: {
    form: {
      header: "Установить новый пароль",
      text: "Введите пароль, который вы будете использовать для входа в систему.",
    },
    popup: {
      header: "Срок действия пароля истек",
      text: "Вы будете перенаправлены на процесс сброса пароля для установки нового.",
    },
    success: {
      header: "Пароль сохранен",
      text: "Ваш пароль был изменен. Теперь вы можете перейти к приложению.",
    },
  },
  PsychologicalTests: {
    cognitive: "Когнитивные тесты",
    personality: "Личностные тесты",
    psychomotor: "Психомоторные тесты",
  },
  ResetPassword: {
    errorText:
      "При сбросе пароля произошла ошибка, пожалуйста, попробуйте позже.",
    formHeader: "Сброс Пароля",
    resetEmailSentPt1: "На адрес электронной почты: ",
    resetEmailSentPt2:
      " отправлено сообщение с инструкциями по процессу сброса пароля.",
    resetInfo:
      "Введите адрес электронной почты вашей учетной записи, чтобы получить ссылку для сброса пароля.",
    setNewPassword: "Установить новый пароль",
    setNewPasswordInfo:
      "Введите пароль, который вы будете использовать для входа в систему.",
    success:
      "Ваш пароль был изменен. Теперь вы можете войти в приложение, используя свой адрес электронной почты и новый пароль.",
    successTitle: "Пароль Сохранен",
  },
  SearchEngine: {
    enterFilter:
      "Вы можете искать по имени, фамилии, номеру ПЕСЕЛ/Идентификатору\nили по дате назначения обследования \nв формате ГГГГ-ММ-ДД.",
    header: "Поиск обследуемых",
    noResults: "Нет результатов поиска",
    noResultsForFilter:
      "Не найдено обследуемых, соответствующих введенным требованиям.",
    placeholderDesktop:
      "Имя, фамилия, ПЕСЕЛ/Идентификатор, дата назначения обследования (ГГГГ-ММ-ДД)",
    placeholderMobile: "Поиск",
    searchForExaminees: "Поиск обследуемых",
  },
  RegistryResults: {
    header: "Реестр обследованных",
    headerMobile: "Реестр обследованных",
    clientAccounts: "Учетные записи клиентов",
    clientAccountsRequired:
      "Необходимо выбрать хотя бы одну учетную запись клиента.",
    foldersRequired: "Выберите хотя бы одну папку.",
    legalBasisRequired:
      "Выберите хотя бы одно правовое основание обследования.",
    folders: "Папки",
    dateFrom: "Дата с",
    dateTo: "Дата по",
    legalBasis: "Правовые основания",
    generateButton: "Создать реестр",
    filesToDownload: "Файлы для скачивания",
    filesRefresh: "Обновить список файлов",
    noFiles: "Нет созданных файлов.",
    exportSucceeded:
      "Запрос на создание реестра принят. Вы получите письмо о завершении (успех или ошибка) по электронной почте.",
    dateRangeError: "Дата «от» не может быть позже даты «до».",
    exportDeletedFileSucceeded: "Файл реестра был удалён.",
    popups: {
      delete: {
        confirmationHeader: "Вы уверены, что хотите удалить файл реестра?",
        confirmationText:
          "После удаления файл реестра не может быть восстановлен.",
        confirmationCheckboxLabel: "Да, я хочу удалить файл реестра",
      },
    },
  },
  PriceList: {
    header: "Прейскурант",
    headerMobile: "Прейскурант",
    testName: "Название теста",
    credits: "Кредиты",
  },
  SendEmail: {
    header: "Отправка уведомлений",
    headerMobile: "Отправка уведомлений",
  },
  Snackbars: {
    createExaminationSuccess: "Обследование успешно назначено",
    extendExaminationSuccess: "Обследование успешно расширено новыми тестами",
    recalculateExaminationSuccess: "Результаты обследования пересчитаны",
    createExamineeSuccess: "Обследуемый успешно добавлен",
    createMultiExaminationSuccess:
      "Исследования успешно импортированы и назначены",
    createPsychLabSuccess: "Аккаунт клиента успешно добавлен",
    createPsychLicSuccess: "Лицензия успешно добавлена",
    createPsychUserSuccess: "Пользователь успешно добавлен",
    deleteExaminationSuccess: "Обследование успешно удалено",
    anonymizePsychLabSuccess: "Данные клиента успешно анонимизированы",
    anonymizePsychLabEmptySuccess:
      "Нет экзаменов для анонимизации. Данные клиента были очищены.",
    deletePsychLabSuccess: "Аккаунт клиента успешно удален",
    editExamineeSuccess: "Обследуемый успешно отредактирован",
    editPsychLabSuccess: "Аккаунт клиента успешно отредактирован",
    editPsychLicSuccess: "Лицензия успешно отредактирована",
    editPsychUserSuccess: "Пользователь успешно отредактирован",
    transferUserDataSuccess: "Обследования и папки успешно перенесены",
    failedRequest: "Возникла проблема: ",
    movingExamineesSuccess: "Успешно перемещено в другую папку",
    examineesListGeneratedSuccess: "Список обследуемых успешно сгенерирован",
    examineesListGeneratedError: "Не удалось сгенерировать список обследуемых",
    deleteExamineeSuccess: "Обследуемый успешно удалён",
    bulkDeleteExamineesSuccess: "Обследуемые успешно удалены: %{deleted}",
    bulkDeleteExamineesPartial:
      "Удалено обследуемых: %{deleted}. Пропущено (есть обследования): %{skipped}",
    passwordChangeSuccess: "Пароль успешно изменен",
    pinChangeSuccess: "ПИН-код успешно изменен",
    success: "Действие выполнено успешно",
    unrecognizedError: "Неопознанная ошибка, проверьте подключение к интернету",
    editTestCreditSuccess: "Цена теста в кредитах успешно сохранена",
    editTestCreditError: "Не удалось сохранить цену теста в кредитах",
    unblockedExamSuccess: "Обследования клиента успешно разблокированы",
  },
  LandscapePrompt: {
    title: "Поверните устройство горизонтально",
    description:
      "Редактирование документации недоступно в портретном режиме. Чтобы продолжить, поверните устройство горизонтально.",
  },
  TwoFactor: {
    backupCode: "Резервный код",
    backupCodes: "Резервные коды",
    backupCodesInfo:
      "Сохраните эти резервные коды в безопасном месте. Вы можете использовать их для доступа к своей учетной записи, если потеряете устройство аутентификации.",
    confirmDisable:
      "Введите пароль, чтобы отключить двухфакторную аутентификацию",
    disableError: "Не удалось отключить двухфакторную аутентификацию",
    disableSuccess: "Двухфакторная аутентификация успешно отключена",
    disableTitle: "Отключить двухфакторную аутентификацию",
    enterBackupCode: "Введите резервный код",
    enterCode: "Введите код подтверждения из приложения аутентификации",
    scanQRCode: "Отсканируйте этот QR-код с помощью приложения аутентификации",
    secretKey: "Секретный ключ",
    setupError: "Не удалось настроить двухфакторную аутентификацию",
    setupSuccess: "Двухфакторная аутентификация успешно настроена",
    setupTitle: "Настроить двухфакторную аутентификацию",
    useAuthenticator: "Использовать аутентификатор",
    useBackupCode: "Использовать резервный код",
    verificationCode: "Код подтверждения",
    verificationError: "Недействительный код подтверждения",
    verifyTitle: "Проверить двухфакторную аутентификацию",
  },
  UserSettings: {
    access: "Доступ",
    facilityInfo: "Информация об учреждении",
    header: "Настройки аккаунта",
    headerChangePassword: "Изменение пароля",
    headerChangePin: "Изменение ПИН-кода",
    headerMobile: "Настройки",
    helpdeskMsgLab:
      "Для изменения информации об учреждении или пользователе позвоните по номеру:",
    helpdeskMsgUser:
      "Для изменения информации об учреждении или пользователе позвоните по номеру:",
    infoSubHeaders: {
      address: "Адрес",
      cin: "Регистрационный номер",
      dateExpire: "Дата истечения аккаунта",
      email: "Электронная почта",
      firstName: "Имя",
      id: "ID клиента",
      labName: "Название",
      lastName: "Фамилия",
      licenseNumber: "Номер лицензии",
      assignedClientAccount: "Учётная запись клиента, к которой вы привязаны",
      tin: "ИНН",
    },
    license: {
      license: "Лицензия",
      dateLicExpire: "Дата истечения срока действия лицензии: ",
      remainingCredits: "Оставшиеся кредиты для использования: ",
      allCredits: "Приобретённые кредиты: ",
      lockedCredits: "Кредиты, заблокированные в обследованиях: ",
      freeCredits: "Доступные кредиты: ",
    },
    passwordChange: "Изменение пароля",
    passwordExpiry: "Срок действия вашего пароля истекает: ",
    pinChange: "Изменение ПИН-кода",
    pinChangeMobile: "Изменение ПИН",
    pinInfo:
      "Введите ПИН-код, который вы будете использовать для входа в консоль психолога.",
    setNewPin: "Установить новый ПИН-код",
    userInfo: "Информация о пользователе",
  },
  CsvHeaders: {
    firstName: "Имя",
    lastName: "Фамилия",
    identificationNumber: "Идентификатор",
    directoryName: "Название папки",
  },
  CsvFileName: {
    examineesList: "список-обследуемых",
  },
  SystemParams: {
    showBatteriesDesc:
      "флаг, указывающий, отображать ли батареи при приглашении на обследование, значения: 0, 1",
    t2sTestsDesc:
      "список тестов, выбранных по умолчанию при выборе методологии T2S, пример значения: SIRT,CHORT,HECOR....",
    t2aTestsDesc:
      "список тестов, выбранных по умолчанию при выборе методологии T2A, пример значения: SIRT,CHORT,HECOR....",
    t2wTestsDesc:
      "список тестов, выбранных по умолчанию при выборе методологии T2W, пример значения: SIRT,CHORT,HECOR....",
    t2dTestsDesc:
      "список тестов, выбранных по умолчанию при выборе методологии T2D, пример значения: SIRT,CHORT,HECOR....",
    selectTestsDesc:
      "список тестов, выбранных по умолчанию при приглашении без правового основания, пример значения: SIRT,CHORT,HECOR....",
    batteriesListDesc:
      "список батарей, видимый при приглашении на обследование, если параметр SHOW_BATTERIES установлен на 1, пример значения: TEST2DRIVE,TEST2SPORT...",
    showRecalculateExamDesc:
      "Показывать ли действие пересчёта обследования в списке для администраторов лаборатории (is_admin), значения: 0, 1",
    showExtendedExamDesc:
      "Разрешать ли расширять закрытые обследования новыми тестами, значения: 0, 1",
    showExamineeRegistryDesc:
      "Реестр обследуемых доступен из панели психолога – отображать ли модуль реестра обследуемых, значения: 0, 1",
    showImportExamineeDesc:
      "Импорт обследуемых доступен из панели психолога, значения: 0, 1",
    allowExportResultDesc:
      "Экспорт результатов доступен из панели психолога, значения: 0, 1",
    passwordExpiryDaysDesc:
      "Количество дней действия пароля пользователя (например, 30, 60, 90)",
    allowDelExaminessDesc:
      "Разрешить ли одновременное удаление нескольких обследуемых, значения: 0, 1",
    allowDelExamineeWithExamDesc:
      "Разрешить ли удаление обследуемого вместе с его обследованиями, значения: 0, 1",
    batteries: "Батарея",
  },
};